import React, { useEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';

import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Input from './Input';
import InputDate from './InputDate';
import consts from '../libs/consts';

import Radios from './Radios';
import Checkbox from './Checkbox';
import Profiles from './Profiles';
import { close, loadingflas, open, listupdater } from '../redux/popupSlice';
import Select from './Select';
import DaumPostcode from 'react-daum-postcode';
import { getBase64, getBase64toDataUrl, getMemberinfo, numFormat } from '../utils/utils';
import InfoViewlists from './InfoViewlists';
import * as APIS from "../utils/service";
import DatePicker from "react-datepicker";

import generatePDF, { Resolution, Margin } from 'react-to-pdf';
import ContractwriterPageViewer from './ContractwriterPageViewer';
import ContractwriterPage2Viewer from './ContractwriterPage2Viewer';
import ContractwriterPage3Viewer from './ContractwriterPage3Viewer';
import lodash from "lodash"

export default function ContractwriterPage1(props) {

    const {
        row={},
        setviewpages=() => {},
        scrolTopFunc=()=>{},
        setdetailwrite=()=>{},
        contractWirteSubmit=()=>{},
        setp_code=()=>{},
        setlist1Viewer=()=>{},
        setlist2Viewer=()=>{},
        setpcodeDatas=()=>{},
        memberinfos={},
        productrow={}
    } = props;
    const { configdata } = useSelector(s => s.configReducer);
    const targetRef = useRef();
    const targetRefconfirm = useRef();
    let category_2_list = configdata?.consts?.category_2_OptionConsts
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [sell_type, setsell_type] = useState('매매');   
    const [category, setcategory] = useState('집합건물');
    const [sub_category, setsub_category] = useState('주거용');
    const [mediation_option, setmediation_option] = useState(0);
    const [errmsg, seterrmsg] = useState('');   
    const [togetherck, settogetherck] = useState([]); 
    
    const [isOpenPost, setIsOpenPost] = useState(false);
    const [isOpenPost2, setIsOpenPost2] = useState(false);
    const [isOpenPost3, setIsOpenPost3] = useState(false);
    const [isOpenPost4, setIsOpenPost4] = useState(false);
    const [isOpenPost5, setIsOpenPost5] = useState(false);
    const [listpopflag, setlistpopflag] = useState(false);
    const [listcustompopflag, setlistcustompopflag] = useState(false);
    const [productlist, setproductlist] = useState([]);
    const [customerlist, setcustomerlist] = useState([]);
    const [pdfdowns, setpdfdowns] = useState([]);
    const [pdfdowns2, setpdfdowns2] = useState([]);


    const [searchvar,setsearchvar] = useState("");
    const [viewList,setviewList] = useState([]);
    //console.log("productrowproductrow", productrow);
    
    
    let yearDatas = [];
    let monthDatas = [];
    let dayDatas = [];
    //{labels: '선택하세요', values: ''}
    let starty = moment().add(-5, 'Y').format('YYYY');
    let endy = moment().add(+5, 'Y').format('YYYY');
    for(let y = starty; y <= endy; y++){
        yearDatas.push({labels: y+'', values: y+''});
    }
    for(let m = 1; m <= 12; m++){
        let monthtxt = m < 10 ? '0'+m : m;
        monthDatas.push({labels: monthtxt+'', values: monthtxt+''});
    }
    for(let d = 1; d <= 31; d++){
        let daytxt = d < 10 ? '0'+d : d;
        dayDatas.push({labels: daytxt+'', values: daytxt+''});
    }

    const [inputArr, setinputArr] = useState([
        {keys: "소재지", values: '', requireCkr: true, errmsg: '소재지를 입력해주세요.'},
        {keys: "소재지동", values: '', requireCkr: false, errmsg: '소재지동을 입력해주세요.'},
        {keys: "소재지호", values: '', requireCkr: false, errmsg: '소재지호를 입력해주세요.'},
        {keys: "토지지목", values: '대', requireCkr: false, errmsg: '토지지목을 입력해주세요.'},
        {keys: "토지면적", values: '', requireCkr: false, errmsg: '토지면적을 입력해주세요.'},
        {keys: "대지권목적", values: '', requireCkr: false, errmsg: '대지권목적을 입력해주세요.'},
        {keys: "대지권면적", values: '', requireCkr: false, errmsg: '대지권면적을 입력해주세요.'},
        {keys: "대지권종류", values: '', requireCkr: false, errmsg: '대지권종류를 입력해주세요.'},
        {keys: "대지권비율", values: '', requireCkr: false, errmsg: '대지권비율을 입력해주세요.'},
        {keys: "대지권비율2", values: '', requireCkr: false, errmsg: '대지권비율2을 입력해주세요.'},
        {keys: "건물구조", values: '철근콘크리트구조', requireCkr: false, errmsg: '건물구조를 입력해주세요.'},
        {keys: "건물용도", values: '직접입력', requireCkr: false, errmsg: '건물용도를 입력해주세요.'},
        {keys: "건물용도직접입력", values: '', requireCkr: false, errmsg: '건물용도를 입력해주세요.'},
        {keys: "건물전용면적", values: '', requireCkr: false, errmsg: '건물전용면적을 입력해주세요.'},
        {keys: "건물연면적", values: '', requireCkr: false, errmsg: '건물연면적을 입력해주세요.'},
        {keys: "임대할부분", values: '', requireCkr: false, errmsg: '임대할부분을 입력해주세요.'},
        {keys: "임대할면적", values: '', requireCkr: false, errmsg: '임대할면적을 입력해주세요.'},
        {keys: "매매대금", values: '', requireCkr: false, errmsg: '매매대금을 입력해주세요.'},
        {keys: "보증금", values: '', requireCkr: false, errmsg: '보증금을 입력해주세요.'},
        {keys: "현임대보증금", values: '', requireCkr: false, errmsg: '현임대보증금을 입력해주세요.'},
        {keys: "계약금", values: '', requireCkr: false, errmsg: '계약금을 입력해주세요.'},
        {keys: "영수자", values: '', requireCkr: false, errmsg: '영수자를 입력해주세요.'},
        {keys: "융자금", values: '', requireCkr: false, errmsg: '융자금을 입력해주세요.'},
        {keys: "중도금", values: [
            {keys: "중도금1", values: [
                {keys: "중도금", values: '', requireCkr: false, errmsg: '두번째 중도금을 입력해주세요.'},
                {keys: "중도금지불일년", values: moment().format('YYYY'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
                {keys: "중도금지불일월", values: moment().format('MM'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
                {keys: "중도금지불일일", values: moment().format('DD'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
            ], requireCkr: false, errmsg: '중도금을 입력해주세요.'},
        ], requireCkr: false, errmsg: '중도금을 입력해주세요.'},
        {keys: "잔금", values: '', requireCkr: false, errmsg: '잔금을 입력해주세요.'},
        {keys: "잔금년", values: moment().format('YYYY'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "잔금월", values: moment().format('MM'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "잔금일", values: moment().format('DD'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "차임", values: '', requireCkr: false, errmsg: '차임을 입력해주세요.'},
        {keys: "차임일", values: moment().format('DD'), requireCkr: false, errmsg: '차임일을 선택해주세요.'},
        {keys: "부동산인도일년", values: moment().format('YYYY'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "부동산인도일월", values: moment().format('MM'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "부동산인도일일", values: moment().format('DD'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "부동산임대차인도일년", values: moment().format('YYYY'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "부동산임대차인도일월", values: moment().format('MM'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "부동산임대차인도일일", values: moment().format('DD'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "부동산임대차인도일개월", values: '', requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "쌍방교부년", values: moment().format('YYYY'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "쌍방교부월", values: moment().format('MM'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "쌍방교부일", values: moment().format('DD'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "특약사항", values: [
            {keys: "특약사항", values: '', requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        ], requireCkr: false, errmsg: '특약사항을 입력해주세요.'},

        {keys: "날인일년", values: moment().format('YYYY'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "날인일월", values: moment().format('MM'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "날인일", values: moment().format('DD'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "매도인", values: [
            {keys: "매도인1", values: [
                {keys: "매도인주소", values: '', requireCkr: false, errmsg: ''},
                {keys: "매도인주민번호선택", values: '주민등록번호', requireCkr: false, errmsg: ''},
                {keys: "매도인주민번호", values: '', requireCkr: false, errmsg: ''},
                {keys: "매도인전화", values: '', requireCkr: false, errmsg: ''},
                {keys: "매도인성명", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인주소", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인주민번호선택", values: '주민등록번호', requireCkr: false, errmsg: ''},
                {keys: "대리인주민번호", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인전화", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인성명", values: '', requireCkr: false, errmsg: ''},
            ], requireCkr: false, subflag: false, errmsg: '중도금을 입력해주세요.'},
        ], requireCkr: false, errmsg: '매도인정보를 입력해주세요.'},
        {keys: "매수인", values: [
            {keys: "매수인", values: [
                {keys: "매수인주소", values: '', requireCkr: false, errmsg: ''},
                {keys: "매수인주민번호선택", values: '주민등록번호', requireCkr: false, errmsg: ''},
                {keys: "매수인주민번호", values: '', requireCkr: false, errmsg: ''},
                {keys: "매수인전화", values: '', requireCkr: false, errmsg: ''},
                {keys: "매수인성명", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인주소", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인주민번호선택", values: '주민등록번호', requireCkr: false, errmsg: ''},
                {keys: "대리인주민번호", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인전화", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인성명", values: '', requireCkr: false, errmsg: ''},
            ], requireCkr: false, subflag: false, errmsg: '중도금을 입력해주세요.'},
        ], requireCkr: false, errmsg: '매수인정보를 입력해주세요.'},
        {keys: "개중사무소소재지1", values: memberinfos?.compony?.addr, requireCkr: false, errmsg: '개업공인중개 사사무소소재지를 입력해주세요.'},
        {keys: "개중사무소명칭1", values: memberinfos?.compony?.title, requireCkr: false, errmsg: '개업공인중개사 사무소명칭을 입력해주세요.'},
        {keys: "개중전화번호1", values: memberinfos?.hp, requireCkr: false, errmsg: '개업공인중개사 전화번호를 입력해주세요.'},
        {keys: "개중등록번호1", values: memberinfos?.compony?.permit_number, requireCkr: false, errmsg: '개업공인중개사 등록번호를 입력해주세요.'},
        {keys: "공동중개여부", values: '', requireCkr: false, errmsg: '공동중개여부를 선택해주세요.'},
        {keys: "공동중개", values: [
            {keys: "공동중개1", values: [
                {keys: "공동중개사무소소재지", values: '', requireCkr: false, errmsg: ''},
                {keys: "공동중개사무소명칭", values: '', requireCkr: false, errmsg: ''},
                {keys: "공동중개전화번호", values: '', requireCkr: false, errmsg: ''},
                {keys: "공동중개등록번호", values: '', requireCkr: false, errmsg: ''},
            ], requireCkr: false, subflag: false, errmsg: ''},
        ], requireCkr: false, errmsg: '공동중개정보를 입력해주세요.'},
    ]);

    useEffect(() => {
        if(row?.idx){
            console.log(row);

            let inputArrData = JSON?.parse(row?.contract);
            console.log(inputArrData);
            console.log(inputArrData?.find(item => item?.keys === '공동중개여부')?.values);
            setsell_type(row?.sell_type);
            setcategory(row?.category);
            setsub_category(row?.sub_category);
            if(inputArrData){
                if(!inputArrData?.find(item => item?.keys === '대지권비율2')?.keys){
                    inputArrData.push({keys: "대지권비율2", values: '', requireCkr: false, errmsg: '대지권비율2을 입력해주세요.'});
                }
                if(!inputArrData?.find(item => item?.keys === '부동산임대차인도일년')?.keys){
                    inputArrData.push({keys: "부동산임대차인도일년", values: moment().format('YYYY'), requireCkr: false, errmsg: '대지권비율2을 입력해주세요.'});
                }
                if(!inputArrData?.find(item => item?.keys === '부동산임대차인도일월')?.keys){
                    inputArrData.push({keys: "부동산임대차인도일월", values: moment().format('MM'), requireCkr: false, errmsg: '대지권비율2을 입력해주세요.'});
                }
                if(!inputArrData?.find(item => item?.keys === '부동산임대차인도일일')?.keys){
                    inputArrData.push({keys: "부동산임대차인도일일", values: moment().format('DD'), requireCkr: false, errmsg: '대지권비율2을 입력해주세요.'});
                }
                if(!inputArrData?.find(item => item?.keys === '부동산임대차인도일개월')?.keys){
                    inputArrData.push({keys: "부동산임대차인도일개월", values: '', requireCkr: false, errmsg: '대지권비율2을 입력해주세요.'});
                }                                                                
                setinputArr(inputArrData);
                if(inputArrData?.find(item => item?.keys === '공동중개여부')?.values){
                    settogetherck(inputArrData?.find(item => item?.keys === '공동중개여부')?.values);
                } else {
                    settogetherck([]);
                }
            }
            
        } else {
            setsell_type('매매');
            setcategory('집합건물');
        }
    }, [row]);
    useEffect(() => {
        listopen();
    }, []);
    useEffect(() => {
        seterrmsg('');
    }, [inputArr]);
    useEffect(() => {
        //setinputArr();

        let inputArrData = inputArr;
        if(row?.idx*1 > 0){
            inputArrData = JSON?.parse(row?.contract);
        }
        // inputArrData = inputArrData?.map(item => item?.keys === '차임' ? {...item, requireCkr: true} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '토지면적' ? {...item, requireCkr: true} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '대지권목적' ? {...item, requireCkr: true} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '대지권면적' ? {...item, requireCkr: true} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '대지권종류' ? {...item, requireCkr: true} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '대지권비율' ? {...item, requireCkr: true} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '임대할부분' ? {...item, requireCkr: true} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '임대할면적' ? {...item, requireCkr: true} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '보증금' ? {...item, requireCkr: true} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '매매대금' ? {...item, requireCkr: true} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '현임대보증금' ? {...item, requireCkr: true} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '융자금' ? {...item, requireCkr: true} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '개중사무소소재지2' ? {...item, requireCkr: false} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '개중사무소명칭2' ? {...item, requireCkr: false} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '개중전화번호2' ? {...item, requireCkr: false} : item);
        // inputArrData = inputArrData?.map(item => item?.keys === '개중등록번호2' ? {...item, requireCkr: false} : item);

        // if(togetherck?.length > 0){
        //     inputArrData = inputArrData?.map(item => item?.keys === '개중사무소소재지2' ? {...item, requireCkr: true} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '개중사무소명칭2' ? {...item, requireCkr: true} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '개중전화번호2' ? {...item, requireCkr: true} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '개중등록번호2' ? {...item, requireCkr: true} : item);
        // }

        // if(sell_type === '매매'){
        //     inputArrData = inputArrData?.map(item => item?.keys === '매도인주소' ? {...item, errmsg: '매도인 주소를 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매도인주민번호' ? {...item, errmsg: '매도인주민번호를 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매도인전화' ? {...item, errmsg: '매도인전화를 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매도인성명' ? {...item, errmsg: '매도인성명을 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매수인주소' ? {...item, errmsg: '매수인주소를 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매수인주민번호' ? {...item, errmsg: '매수인주민번호를 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매수인전화' ? {...item, errmsg: '매수인전화를 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매수인성명' ? {...item, errmsg: '매수인성명을 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '임대할부분' ? {...item, requireCkr: false} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '임대할면적' ? {...item, requireCkr: false} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '보증금' ? {...item, requireCkr: false} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '차임' ? {...item, requireCkr: false} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '차임일' ? {...item, requireCkr: false} : item);
        // } else {
        //     inputArrData = inputArrData?.map(item => item?.keys === '매도인주소' ? {...item, errmsg: '임대인 주소를 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매도인주민번호' ? {...item, errmsg: '임대인주민번호를 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매도인전화' ? {...item, errmsg: '임대인전화를 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매도인성명' ? {...item, errmsg: '임대인성명을 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매수인주소' ? {...item, errmsg: '임차인주소를 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매수인주민번호' ? {...item, errmsg: '임차인주민번호를 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매수인전화' ? {...item, errmsg: '임차인전화를 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매수인성명' ? {...item, errmsg: '임차인성명을 입력해주세요.'} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '매매대금' ? {...item, requireCkr: false} : item);
        //     if((sell_type === '전세' || sell_type === '월세') && category === '집합건물'){
        //         inputArrData = inputArrData?.map(item => item?.keys === '현임대보증금' ? {...item, requireCkr: false} : item);
        //         inputArrData = inputArrData?.map(item => item?.keys === '융자금' ? {...item, requireCkr: false} : item);
        //     }
        // }
        // if(sell_type === '전세'){
        //     inputArrData = inputArrData?.map(item => item?.keys === '차임' ? {...item, requireCkr: false} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '차임일' ? {...item, requireCkr: false} : item);
        // }       
        // if(category === '집합건물'){
        //     inputArrData = inputArrData?.map(item => item?.keys === '토지면적' ? {...item, requireCkr: false} : item);
        // }
        // if(category === '일반건물'){
        //     inputArrData = inputArrData?.map(item => item?.keys === '대지권목적' ? {...item, requireCkr: false} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '대지권면적' ? {...item, requireCkr: false} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '대지권종류' ? {...item, requireCkr: false} : item);
        //     inputArrData = inputArrData?.map(item => item?.keys === '대지권비율' ? {...item, requireCkr: false} : item);
        // }

        if(productrow?.idx){
            let x = productrow;
            console.log(x);
            setsell_type(x?.sell_type);
            setcategory(x?.jibhap === '일반' ? '일반건물' : '집합건물');
            setp_code(x?.p_code);
            
            inputArrData = inputArrData?.map(item => item?.keys === '소재지' ? {...item, values: x?.addr} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '소재지동' ? {...item, values: x?.building_dong} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '소재지호' ? {...item, values: x?.building_unit} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지면적' ? {...item, values: x?.area_land} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '건물전용면적' ? {...item, values: x?.area_private} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '매매대금' ? {...item, values: x?.price_sell} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '보증금' ? {...item, values: x?.price_all} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '차임' ? {...item, values: x?.price_month} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '매수인성명' ? {...item, values: x?.client_name} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '매수인전화' ? {...item, values: x?.client_hp} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '건물용도' ? {...item, values: x?.item_usage} : item);
            console.log(inputArrData);
            setinputArr(inputArrData);
            setlistpopflag(false);
        }
        setinputArr(inputArrData);
    }, [sell_type, category]);
    const onCompletePost = (data) => {
        let fullAddr = data.address;
        let extraAddr = '';

        //console.log('data', data);
        
        //let jibunAddress = jibunAddress;

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddr += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddr += extraAddr !== '' ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddr += extraAddr !== '' ? ` (${extraAddr})` : '';
        }
        //console.log(data);

        // setaddrDatas({
        //     addr: data.address,
        //     sido: data?.sido,
        //     sigungu: data?.sigungu || data?.sido,
        //     dong: data?.bname1 || data?.bname
        // });
        if(isOpenPost){
            setpcodeDatas([]);
            setinputArr(inputArr?.map(item => item?.keys === '소재지' ? {...item, values: data.address} : item));

            let p_code = data?.bcode;
            let jibunex = data?.jibunAddress.split(' ');
            let mountain_yn = jibunex[jibunex?.length-2] === '산' ? '1' : '0';
            let address_no_ex = jibunex[jibunex?.length-1].split('-');
            let main_address_no = address_no_ex[0];
            let sub_address_no = address_no_ex[1];
            p_code += mountain_yn;
            p_code += main_address_no?.padStart(4, "0");
            p_code += sub_address_no ? sub_address_no?.padStart(4, "0") : '0000';
            //p_code 식별코드 확인후 총괄표제부 등등 확인
            // 4688037022101240000
            // 4688037022101240000
            setlist1Viewer(0);
            setlist2Viewer(0);
            setp_code(p_code);
            console.log(p_code, jibunex, mountain_yn, address_no_ex, jibunex[jibunex?.length-2]);
            
        }
        if(isOpenPost2){
            setinputArr(inputArr?.map(item => item?.keys === '매도인주소' ? {...item, values: data.address} : item));
        }
        if(isOpenPost3){
            setinputArr(inputArr?.map(item => item?.keys === '매수인주소' ? {...item, values: data.address} : item));
        }
        if(isOpenPost4){
            setinputArr(inputArr?.map(item => item?.keys === '개중사무소소재지1' ? {...item, values: data.address} : item));
        }
        if(isOpenPost5){
            setinputArr(inputArr?.map(item => item?.keys === '개중사무소소재지2' ? {...item, values: data.address} : item));
        }
        setIsOpenPost(false);
        setIsOpenPost2(false);
        setIsOpenPost3(false);
        setIsOpenPost4(false);
        setIsOpenPost5(false);
    };    
    const postBoxStyle = {
        display: 'block',
        position: 'relative',
        width: '100%',
        border: '1px solid #000',
        marginTop: 5,
        textAlign: 'right'
    };
    const postCodeStyle = {
        width: '100%',
        borderTop: '1px solid #000',
    };
    const listopen = () => {
        let sender = {}
        APIS.postData('/v1/contract/searchList', sender).then(({ data }) => {
            if(data){
                setproductlist(data?.item);
                setviewList(data?.item);
                setcustomerlist(data?.customer);
            }

        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });           
    }
    
    const addropennerFunc = (fkeys='', fkeys2='', indexn = '', flags = false) => {
        setinputArr(inputArr?.map((x, i) => {
            if(x?.keys === fkeys){
                return {...x, values: x?.values?.map((x2, i2) => {
                    return {...x, subflag: x2?.subflag, values: x2?.values?.map((x3, i3) => {
                        if(x3?.keys === fkeys2 && i2 === indexn){
                            return {...x3, requireCkr: flags};
                        } else {
                            return x3;
                        }
                    })}
                })}
            } else {
                return x;
            }
        })); 
    }
    const addrvaluesFunc = (fkeys='', fkeys2='', indexn = '', data = {}) => {
        setinputArr(inputArr?.map((x, i) => {
            if(x?.keys === fkeys){
                return {...x, values: x?.values?.map((x2, i2) => {
                    return {...x, subflag: x2?.subflag, values: x2?.values?.map((x3, i3) => {
                        if(x3?.keys === fkeys2 && i2 === indexn){
                            return {...x3, values: data.address, requireCkr: false};
                        } else {
                            return x3;
                        }
                    })}
                })}
            } else {
                return x;
            }
        }));    
    }
    const datavaluesFunc = (fkeys='', fkeys2='', indexn = '', data) => {
        //console.log(inputArr);
        //return;
        setinputArr(inputArr?.map((x, i) => {
            if(x?.keys === fkeys){
                return {...x, values: x?.values?.map((x2, i2) => {
                    return {...x, subflag: x2?.subflag, values: x2?.values?.map((x3, i3) => {
                        if(x3?.keys === fkeys2 && i2 === indexn){
                            return {...x3, values: data};
                        } else {
                            return x3;
                        }
                    })}
                })}
            } else {
                return x;
            }
        }));    
    }
    // useEffect(() => {
    //     inputArr?.map((x, i) => {
    //         if(x?.keys === '매도인'){
    //             console.log(x?.values[0]);
    //         }
    //     });
    // }, [inputArr]);

    // 매물장 가져오기 필터링
    const importFilterFunc = (srtxt) => {
        return productlist?.filter(v =>{
            if(v){
                if(
                    String(v?.idx).includes(srtxt) || 
                    v?.addr?.includes(srtxt) ||
                    v?.title?.includes(srtxt) ||
                    v?.client_hp?.includes(srtxt) ||
                    v?.item_usage?.includes(srtxt) ||
                    v?.desc?.includes(srtxt)
                ){
                    return true;
                }else{
                    return false
                }
            }
            return true
        })
    }

    useEffect(()=>{
        setviewList(importFilterFunc(searchvar));
    },[searchvar])

    return (
        <>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column', gap: 20}}>
            <div
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}
            >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 8 }}>
                    <Button
                        buttonTxt={'매물장에서 가져오기'}
                        className={'linenormalbutton'}
                        onPress={() => {
                            setlistpopflag(true);
                        }}                   
                        styles={{
                            fontSize: 14, width: 160, height: 36
                        }}          
                    />
                    {/* <Button
                        buttonTxt={'고객목록에서 불러오기'}
                        className={'linenormalbutton'}
                        onPress={() => {
                            setlistcustompopflag(true);
                        }}                   
                        styles={{
                            fontSize: 14, width: 160, height: 36
                        }}          
                    />                     */}
                </div>
                {row?.idx*1 > 0 &&
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 8 }}>
                    <Button
                        buttonTxt={'삭제'}
                        className={'linenormalbutton'}
                        onPress={() => {

                            dispatch(
                                open({
                                    component: '삭제하시겠습니까?',
                                    title: '삭제하기',
                                    button: "삭제",
                                    buttonCencle: "닫기",       
                                    titleviewer: true,                 
                                    alert: false,
                                    onPress: () => {
                                        dispatch(loadingflas({ loading: true }));
                                        let sender = {
                                            idx: row?.idx,
                                        }
                                        APIS.postData('/v1/contract/remove', sender).then(({ data }) => {
                                            if(data){
                                                setdetailwrite(false);
                                                dispatch(listupdater({ listupdate: true }));
                                                dispatch(
                                                    open({
                                                        component: `삭제되었습니다.`,
                                                        title: '알림',
                                                        titleviewer: true,
                                                        alert: false,
                                                        button: "확인",
                                                        onPress: () => {
                                                            dispatch(close());
                                                        }
                                                    })
                                                ); 
                                            }
                                        }).catch(({ response }) => {
                                            const { data } = response;
                                            dispatch(
                                                open({
                                                    component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                                    title: '알림',
                                                    button: "확인",
                                                    titleviewer: true,                 
                                                    alert: false,
                                                    onPress: () => {
                                                        dispatch(close());
                                                    },
                                                })
                                            );      
                                        }).finally(() => {
                                            dispatch(loadingflas({ loading: false }));
                                        }); 
                                    },
                                    onCancelPress: () => {
                                        dispatch(close());
                                    }
                                })
                            );  
                            
                        }}                   
                        styles={{
                            fontSize: 14, width: 80, height: 36
                        }}          
                    />
                    <Button
                        buttonTxt={'계약서 PDF 저장'}
                        onPress={() => {
                            let filenamemonth = inputArr?.find(item => item?.keys === '날인일월')?.values;
                            let filenameday = inputArr?.find(item => item?.keys === '날인일')?.values;
                            let buyname = inputArr?.find(item => item?.keys === '매도인')?.values[0]?.values?.find(item => item?.keys === '매도인성명')?.values;
                            let sellname = inputArr?.find(item => item?.keys === '매수인')?.values[0]?.values?.find(item => item?.keys === '매수인성명')?.values;
                            let filenames = `${filenamemonth}${filenameday} ${buyname},${sellname}-${sell_type} 계약서`;
                            
                            if(!buyname || buyname == ''){
                                dispatch(
                                    open({
                                        component: `매도인(임대인)성명을 입력해주세요.`,
                                        title: '알림',
                                        titleviewer: true,
                                        alert: false,
                                        button: "확인",
                                        onPress: () => {
                                            dispatch(close());
                                        }
                                    })
                                ); 
                                return;
                            }
                            if(!sellname || sellname == ''){
                                dispatch(
                                    open({
                                        component: `매수인(임차인)성명을 입력해주세요.`,
                                        title: '알림',
                                        titleviewer: true,
                                        alert: false,
                                        button: "확인",
                                        onPress: () => {
                                            dispatch(close());
                                        }
                                    })
                                ); 
                                return;
                            }                            
                            dispatch(loadingflas({ loading: true }));
                            contractWirteSubmit(row?.idx ? row?.idx : null, sell_type, category, togetherck?.length > 0 ? 1 : 0, inputArr, sub_category, true);
                            setTimeout(() => {
                                setpdfdowns(true);
                                dispatch(loadingflas({ loading: true }));
                                setTimeout(() => {
                                    generatePDF(targetRef, {
                                        // default is `save`
                                        filename: filenames,
                                        method: 'save',
                                        // default is Resolution.MEDIUM = 3, which should be enough, higher values
                                        // increases the image quality but also the size of the PDF, so be careful
                                        // using values higher than 10 when having multiple pages generated, it
                                        // might cause the page to crash or hang.
                                        resolution: 2,
                                        page: {
                                            // margin is in MM, default is Margin.NONE = 0
                                            margin: Margin.SMALL,
                                        },
                                        // Customize any value passed to the jsPDF instance and html2canvas
                                        // function. You probably will not need this and things can break, 
                                        // so use with caution.
                                        overrides: {
                                            // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
                                            pdf: {
                                                compress: true
                                            },
                                        },
                                    })
                                }, 500);
                                setTimeout(() => {
                                    setpdfdowns(false);
                                    dispatch(loadingflas({ loading: false }));
                                }, 2000);
                            }, 1000);
                        }}                   
                        styles={{
                            fontSize: 14, width: 120, height: 36
                        }}          
                    />                    
                    <Button
                        buttonTxt={'확인설명서 PDF 저장'}
                        onPress={() => {

                            let filenamemonth = inputArr?.find(item => item?.keys === '날인일월')?.values;
                            let filenameday = inputArr?.find(item => item?.keys === '날인일')?.values;
                            let buyname = inputArr?.find(item => item?.keys === '매도인')?.values[0]?.values?.find(item => item?.keys === '매도인성명')?.values;
                            let sellname = inputArr?.find(item => item?.keys === '매수인')?.values[0]?.values?.find(item => item?.keys === '매수인성명')?.values;
                            let filenames = `${filenamemonth}${filenameday} ${buyname},${sellname}-${sell_type} 확인설명서`;
                            
                            if(!buyname || buyname == ''){
                                dispatch(
                                    open({
                                        component: `매도인(임대인)성명을 입력해주세요.`,
                                        title: '알림',
                                        titleviewer: true,
                                        alert: false,
                                        button: "확인",
                                        onPress: () => {
                                            dispatch(close());
                                        }
                                    })
                                ); 
                                return;
                            }
                            if(!sellname || sellname == ''){
                                dispatch(
                                    open({
                                        component: `매수인(임차인)성명을 입력해주세요.`,
                                        title: '알림',
                                        titleviewer: true,
                                        alert: false,
                                        button: "확인",
                                        onPress: () => {
                                            dispatch(close());
                                        }
                                    })
                                ); 
                                return;
                            }                  
                            dispatch(loadingflas({ loading: true }));
                            contractWirteSubmit(row?.idx ? row?.idx : null, sell_type, category, togetherck?.length > 0 ? 1 : 0, inputArr, sub_category, true);
                            setTimeout(() => {
                                setpdfdowns2(true);
                                dispatch(loadingflas({ loading: true }));
                                setTimeout(() => {
                                    generatePDF(targetRefconfirm, {
                                        // default is `save`
                                        filename: filenames,
                                        method: 'save',
                                        // default is Resolution.MEDIUM = 3, which should be enough, higher values
                                        // increases the image quality but also the size of the PDF, so be careful
                                        // using values higher than 10 when having multiple pages generated, it
                                        // might cause the page to crash or hang.
                                        resolution: 2,
                                        page: {
                                            // margin is in MM, default is Margin.NONE = 0
                                            margin: Margin.SMALL,
                                        },
                                        // Customize any value passed to the jsPDF instance and html2canvas
                                        // function. You probably will not need this and things can break, 
                                        // so use with caution.
                                        overrides: {
                                            // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
                                            pdf: {
                                                compress: true
                                            },
                                        },
                                    })
                                }, 500);
                                setTimeout(() => {
                                    setpdfdowns2(false);
                                    dispatch(loadingflas({ loading: false }));
                                }, 2000);
                            }, 1000);
                            
                        }}                   
                        styles={{
                            fontSize: 14, width: 140, height: 36
                        }}          
                    />                    
                </div>    }            
            </div>
            <div 
                className='fontsize12' 
                style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 8
                }}
            >
                <div>
                    <Select 
                        styles={{ border: '0px', fontSize: 30, fontWeight: 700, padding: '0 30px 0 0'}}
                        setValues={setcategory}
                        values={category}
                        selectData={[
                            {labels: '집합', values: '집합건물'},
                            {labels: '일반', values: '일반건물'},
                        ]}
                    />                     
                </div>
                <div>
                    <Select 
                        styles={{ border: '0px', fontSize: 30, fontWeight: 700, padding: '0 30px 0 0' }}
                        setValues={setsell_type}
                        values={sell_type}
                        selectData={[
                            {labels: '매매', values: '매매'},
                            {labels: '전세', values: '전세'},
                            {labels: '월세', values: '월세'},
                        ]}
                    />                     
                </div>
                <div style={{ fontSize: 30, fontWeight: 700 }}>계약서</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                <Radios
                    linetype={'checkimg'}
                    values={sub_category}
                    setvalues={setsub_category}
                    namevalue={[
                        {names: '주거용', values: '주거용'},
                        {names: '비주거용', values: '비주거용'},
                    ]}
                    fontweights={400}
                    fontSizes={14}
                    sizes={20}
                />                
            </div>
            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable'>
                    <tr>
                        <th colSpan={30}>
                            <p>매도인과 매수인 쌍방은 아래 표시 부동산에 관하여 다음 계약 내용과 같이 매매계약을 체결한다.</p>
                            <p className='bolds margint8'>1.부동산의 표시</p>
                        </th>
                    </tr>
                    <tr>
                        <th className='justifys' colSpan={3}>소 재 지</th>
                        <td colSpan={27}>
                            <div className='buttonWithTxt' style={{ marginTop: 0 }}>
                                <div>
                                    <Button
                                        className={'normalbutton_middle'}
                                        buttonTxt={'주소찾기'}
                                        onPress={() => {
                                            setIsOpenPost(!isOpenPost);
                                        }}
                                    />
                                </div>
                                <div style={{ width: 'calc(100% - 300px)'}}>
                                    <Input 
                                        className={`inputs`}
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '소재지' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '소재지')?.values}
                                        name="mb_phone"
                                    /> 
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, width: 208}}>
                                    <div>
                                        <Input 
                                            className={`inputs`}
                                            rightplaceholder="동"
                                            setValue={(e) => {
                                                setinputArr(inputArr?.map(item => item?.keys === '소재지동' ? {...item, values: e} : item));
                                            }}
                                            value={inputArr?.find(item => item?.keys === '소재지동')?.values}
                                            name="mb_phone"
                                            style={{
                                                paddingRight: 30, textAlign: 'right', width: 100
                                            }}
                                        />  
                                    </div>
                                    <div>
                                        <Input 
                                            className={`inputs`}
                                            rightplaceholder="호"
                                            setValue={(e) => {
                                                setinputArr(inputArr?.map(item => item?.keys === '소재지호' ? {...item, values: e} : item));
                                            }}
                                            value={inputArr?.find(item => item?.keys === '소재지호')?.values}
                                            name="mb_phone"
                                            style={{
                                                paddingRight: 30, textAlign: 'right', width: 100
                                            }}
                                        />  
                                    </div>  
                                </div>
                            </div>
                            {isOpenPost  ? (
                                <div style={postBoxStyle}>
                                    <button type="button" className="addrbtn exit_btn" onClick={() => setIsOpenPost(false)} style={{ padding: 10 }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.79289C5.68342 5.40237 6.31658 5.40237 6.70711 5.79289L12 11.0858L17.2929 5.79289C17.6834 5.40237 18.3166 5.40237 18.7071 5.79289C19.0976 6.18342 19.0976 6.81658 18.7071 7.20711L13.4142 12.5L18.7071 17.7929C19.0976 18.1834 19.0976 18.8166 18.7071 19.2071C18.3166 19.5976 17.6834 19.5976 17.2929 19.2071L12 13.9142L6.70711 19.2071C6.31658 19.5976 5.68342 19.5976 5.29289 19.2071C4.90237 18.8166 4.90237 18.1834 5.29289 17.7929L10.5858 12.5L5.29289 7.20711C4.90237 6.81658 4.90237 6.18342 5.29289 5.79289Z" fill="#999999"/>
                                        </svg>                            
                                    </button>
                                    <DaumPostcode style={postCodeStyle} autoClose onComplete={onCompletePost} />
                                </div>
                            ) : null}                              
                        </td>
                    </tr>
                    {category === '일반건물' &&
                    <tr>
                        <th className='justifys' colSpan={3} >토 지</th>
                        <th className='justifys' colSpan={2} >지 목</th>
                        <td colSpan={17}>

                            <Select 
                                divwidth={{  height: 30 }}
                                styles={{ height: 30 }}  
                                setValues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '토지지목' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '토지지목')?.values}
                                selectData={[
                                    {labels: '대', values: '대'},
                                    {labels: '전', values: '전'},
                                    {labels: '답', values: '답'},
                                    {labels: '과수원', values: '과수원'},
                                    {labels: '목장용지', values: '목장용지'},
                                    {labels: '임야', values: '임야'},
                                    {labels: '광천지', values: '광천지'},
                                    {labels: '염전', values: '염전'},
                                    {labels: '공장용지', values: '공장용지'},
                                    {labels: '학교용지', values: '학교용지'},
                                    {labels: '주차장', values: '주차장'},
                                    {labels: '주유소용지', values: '주유소용지'},
                                    {labels: '창고용지', values: '창고용지'},
                                    {labels: '도로', values: '도로'},
                                    {labels: '제방', values: '제방'},
                                    {labels: '하천', values: '하천'},
                                    {labels: '구거', values: '구거'},
                                    {labels: '유지', values: '유지'},
                                    {labels: '양어장', values: '양어장'},
                                    {labels: '수도용지', values: '수도용지'},
                                    {labels: '공원', values: '공원'},
                                    {labels: '철도용지', values: '철도용지'},
                                    {labels: '체육욧지', values: '체육욧지'},
                                    {labels: '유원지', values: '유원지'},
                                    {labels: '종교용지', values: '종교용지'},
                                    {labels: '사적지', values: '사적지'},
                                    {labels: '묘지', values: '묘지'},
                                    {labels: '잡종지', values: '잡종지'},
                                ]}
                            />
                        </td>
                        
                        
                        <th className='justifys' colSpan={3} >면 적</th>
                        <td colSpan={5}>
                            <Input 
                                className={`inputs`}
                                rightplaceholder="㎡"
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '토지면적' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '토지면적')?.values}
                                name="mb_phone"
                                style={{
                                    paddingRight: 32, textAlign: 'right'
                                }}
                            />  
                        </td>
                    </tr>
                    }
                    {category === '집합건물' &&
                    <>
                    <tr>
                        <th className='justifys' colSpan={3} rowSpan={2} >대 지 권</th>
                        <th className='justifys' colSpan={2} rowSpan={2}  >지 목</th>
                        <td colSpan={6} rowSpan={2} >
                            <Select 
                                divwidth={{  height: 30 }}
                                styles={{ height: 30 }}  
                                setValues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '토지지목' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '토지지목')?.values}
                                selectData={[
                                    {labels: '대', values: '대'},
                                    {labels: '전', values: '전'},
                                    {labels: '답', values: '답'},
                                    {labels: '과수원', values: '과수원'},
                                    {labels: '목장용지', values: '목장용지'},
                                    {labels: '임야', values: '임야'},
                                    {labels: '광천지', values: '광천지'},
                                    {labels: '염전', values: '염전'},
                                    {labels: '공장용지', values: '공장용지'},
                                    {labels: '학교용지', values: '학교용지'},
                                    {labels: '주차장', values: '주차장'},
                                    {labels: '주유소용지', values: '주유소용지'},
                                    {labels: '창고용지', values: '창고용지'},
                                    {labels: '도로', values: '도로'},
                                    {labels: '제방', values: '제방'},
                                    {labels: '하천', values: '하천'},
                                    {labels: '구거', values: '구거'},
                                    {labels: '유지', values: '유지'},
                                    {labels: '양어장', values: '양어장'},
                                    {labels: '수도용지', values: '수도용지'},
                                    {labels: '공원', values: '공원'},
                                    {labels: '철도용지', values: '철도용지'},
                                    {labels: '체육욧지', values: '체육욧지'},
                                    {labels: '유원지', values: '유원지'},
                                    {labels: '종교용지', values: '종교용지'},
                                    {labels: '사적지', values: '사적지'},
                                    {labels: '묘지', values: '묘지'},
                                    {labels: '잡종지', values: '잡종지'},
                                ]}
                            />
                        </td>
                        <th className='justifys' colSpan={2}  rowSpan={2} >면 적</th>
                        <td colSpan={4} rowSpan={2} >
                            <Input 
                                className={`inputs`}
                                rightplaceholder="㎡"
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대지권면적' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대지권면적')?.values}
                                name="mb_phone"
                                style={{
                                    paddingRight: 32, textAlign: 'right'
                                }}
                            />  
                        </td>
                        <th className='justifys' colSpan={3} >대지권종류</th>
                        <td colSpan={10}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대지권종류' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대지권종류')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />
                        </td>
                    </tr>   
                    <tr>
                        <th className='justifys' colSpan={3} >대지권비율</th>
                        <td colSpan={10} >
                            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'row', gap: 10}}>
                                <div style={{ width: 80 }}>
                                    <Input 
                                        className={`inputs`}
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '대지권비율' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '대지권비율')?.values}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                                분의
                                <div style={{ width: 80 }}>
                                    <Input 
                                        className={`inputs`}
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '대지권비율2' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '대지권비율2')?.values}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                            </div>
                        </td>
                    </tr>     
                    </>
                    }              
                    <tr>
                        <th className='justifys' colSpan={3} >건 물</th>
                        <th className='justifys' colSpan={2} >구 조</th>
                        <td colSpan={6}>
                            <Select 
                                divwidth={{  height: 30 }}
                                styles={{ height: 30 }}  
                                setValues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '건물구조' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '건물구조')?.values}
                                selectData={[
                                    {labels: '철근콘크리트구조', values: '철근콘크리트구조'},
                                    {labels: '콘크리트구조', values: '콘크리트구조'},
                                    {labels: '철골구조', values: '철골구조'},
                                    {labels: '일반철골구조', values: '일반철골구조'},
                                    {labels: '경량철골구조', values: '경량철골구조'},
                                    {labels: '철골철근콘크리트구조', values: '철골철근콘크리트구조'},
                                    {labels: '철골콘크리트구조', values: '철골콘크리트구조'},
                                    {labels: '철골철근콘크리트구조', values: '철골철근콘크리트구조'},
                                    {labels: '경량철골조', values: '경량철골조'},
                                    {labels: '기타철골철근콘크리트구조', values: '기타철골철근콘크리트구조'},
                                    {labels: '연와조', values: '연와조'},
                                    {labels: '벽돌구조', values: '벽돌구조'},
                                    {labels: '직접입력', values: '직접입력'},
                                ]}
                            />
                        </td>
                        <th className='justifys' colSpan={2} >용 도</th>
                        <td colSpan={9}>
                            <Select 
                                divwidth={{  height: 30 }}
                                styles={{ height: 30 }}  
                                setValues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '건물용도' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '건물용도')?.values}
                                selectData={[
                                    { labels: '단독주택', values: '단독주택' },
                                    { labels: '공동주택', values: '공동주택' },
                                    { labels: '제1종 근린생활시설', values: '제1종 근린생활시설' },
                                    { labels: '제2종 근린생활시설', values: '제2종 근린생활시설' },
                                    { labels: '업무시설', values: '업무시설' },
                                    { labels: '판매시설', values: '판매시설' },
                                    { labels: '교육연구시설', values: '교육연구시설' },
                                    { labels: '운동시설', values: '운동시설' },
                                    { labels: '의료시설', values: '의료시설' },
                                    { labels: '숙박시설', values: '숙박시설' },
                                    { labels: '위락시설', values: '위락시설' },
                                    { labels: '문화 및 집회시설', values: '문화 및 집회시설' },
                                    { labels: '공장', values: '공장' },
                                    { labels: '창고시설', values: '창고시설' },
                                    { labels: '노유자시설', values: '노유자시설' },
                                    { labels: '종교시설', values: '종교시설' },
                                    { labels: '수련시설', values: '수련시설' },
                                    { labels: '운수시설', values: '운수시설' },
                                    { labels: '자동차 관련 시설', values: '자동차 관련 시설' },
                                    { labels: '위험물 저장 및 처리 시설', values: '위험물 저장 및 처리 시설' },
                                    { labels: '동물 및 식물 관련 시설', values: '동물 및 식물 관련 시설' },
                                    { labels: '자원순환 관련 시설', values: '자원순환 관련 시설' },
                                    { labels: '교정 및 군사 시설', values: '교정 및 군사 시설' },
                                    { labels: '방송통신시설', values: '방송통신시설' },
                                    { labels: '발전시설', values: '발전시설' },
                                    { labels: '묘지 관련 시설', values: '묘지 관련 시설' },
                                    { labels: '관광 휴게시설', values: '관광 휴게시설' },
                                    { labels: '장례시설', values: '장례시설' },
                                    { labels: '야영장 시설', values: '야영장 시설' },
                                    { labels: '미등기건물', values: '미등기건물' },
                                    { labels: '그 밖에 토지의 정착물', values: '그 밖에 토지의 정착물' },
                                    {labels: '직접입력', values: '직접입력'},
                                ]}
                            />              
                            {inputArr?.find(item => item?.keys === '건물용도')?.values === '직접입력' &&
                            <>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '건물용도직접입력' ? {...item, values: e} : item));
                                    }}
                                    value={inputArr?.find(item => item?.keys === '건물용도직접입력')?.values}
                                    name="mb_phone"
                                /> 
                            </>
                            }              
                        </td>
                        {/* <th className='justifys' colSpan={3} style={{ letterSpacing: -1 }}>전 용 면 적</th>
                        <td colSpan={4}>
                            <Input 
                                className={`inputs`}
                                rightplaceholder="㎡"
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '건물전용면적' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '건물전용면적')?.values}
                                name="mb_phone"
                                style={{
                                    paddingRight: 32, textAlign: 'right'
                                }}
                            /> 
                        </td> */}
                        <th className='justifys' colSpan={3} >{category === '집합건물' ? "면 적" : "연 면 적"}</th>
                        <td colSpan={5}>
                            <Input 
                                className={`inputs`}
                                rightplaceholder="㎡"
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '건물연면적' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '건물연면적')?.values}
                                name="mb_phone"
                                style={{
                                    paddingRight: 32, textAlign: 'right'
                                }}
                            /> 
                        </td>
                    </tr>
                    {(sell_type === '전세' || sell_type === '월세') &&
                    <tr>
                        <th className='justifys' colSpan={3} >임대할 부분</th>
                        <td colSpan={19}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '임대할부분' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '임대할부분')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />
                        </td>
                        <th className='justifys' colSpan={3} >면 적</th>
                        <td colSpan={5}>
                            <Input 
                                className={`inputs`}
                                rightplaceholder="㎡"
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '임대할면적' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '임대할면적')?.values}
                                name="mb_phone"
                                style={{
                                    paddingRight: 32, textAlign: 'right'
                                }}
                            /> 
                        </td>
                    </tr>
                    }
                    <tr>
                        <th colSpan={30}>
                            <p className='bolds'>2. 계약내용</p>
                            <p className='margint8'>제1조 (목적) 위 부동산의 매매에 대하여 매도인과 매수인은 합의에 의하여 매매대금을 아래와 같이 지불하기로 한다.</p>
                        </th>
                    </tr>
                    {sell_type === '매매' &&
                    <tr>
                        <th className='justifys' colSpan={3} >매 매 대 금</th>
                        <td colSpan={27}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                금 
                                <div style={{ width: 160 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '매매대금' ? {...item, values: e} : item));
                                    }}
                                    value={inputArr?.find(item => item?.keys === '매매대금')?.values}
                                    name="mb_phone"
                                    style={{
                                        textAlign: 'right'
                                    }}
                                />   
                                </div>                         
                                원정 (₩{numFormat(inputArr?.find(item => item?.keys === '매매대금')?.values*10000)})
                            </div>
                        </td>
                    </tr>}
                    {sell_type !== '매매' &&
                    <tr>
                        <th className='justifys' colSpan={3} >보 증 금</th>
                        <td colSpan={27}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                금 
                                <div style={{ width: 160 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '보증금' ? {...item, values: e} : item));
                                    }}
                                    value={inputArr?.find(item => item?.keys === '보증금')?.values}
                                    name="mb_phone"
                                    style={{
                                        textAlign: 'right'
                                    }}
                                />   
                                </div>                         
                                원정 (₩{numFormat(inputArr?.find(item => item?.keys === '보증금')?.values*10000)})
                            </div>
                        </td>
                    </tr>}
                    {/* 
                    {((sell_type === '전세' || sell_type === '월세') && category === '집합건물') ? 
                    <></>
                    :
                    <tr>
                        <th className='justifys' colSpan={3} style={{ letterSpacing: -1 }}>현임대보증금</th>
                        <td colSpan={27}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                금 
                                <div style={{ width: 160 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '현임대보증금' ? {...item, values: e} : item));
                                    }}
                                    value={inputArr?.find(item => item?.keys === '현임대보증금')?.values}
                                    name="mb_phone"
                                    style={{
                                        textAlign: 'right'
                                    }}
                                />   
                                </div>                         
                                원
                            </div>
                        </td>
                    </tr>} */}
                    
                    <tr>
                        <th className='justifys' colSpan={3} >계 약 금</th>
                        <td colSpan={20}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                금 
                                <div style={{ width: 160 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '계약금' ? {...item, values: e} : item));
                                    }}
                                    value={inputArr?.find(item => item?.keys === '계약금')?.values}
                                    name="mb_phone"
                                    style={{
                                        textAlign: 'right'
                                    }}
                                />   
                                </div>     
                                만원은 계약시 지불하고 영수함.                    
                                
                            </div>

                        </td>
                        <th className='justifys' colSpan={3} >영 수 자</th>
                        <td colSpan={4}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                <div style={{ width: 200 }}>
                                    <Input 
                                        className={`inputs`}
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '영수자' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '영수자')?.values}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>                         
                                (인)
                            </div>

                        </td>
                    </tr>
                    {/* {((sell_type === '전세' || sell_type === '월세') && category === '집합건물') ? 
                    <></>
                    :
                    <tr>
                        <th className='justifys' colSpan={3} >융 자 금</th>
                        <td colSpan={27}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                금 
                                <div style={{ width: 160 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '융자금' ? {...item, values: e} : item));
                                    }}
                                    value={inputArr?.find(item => item?.keys === '융자금')?.values}
                                    name="mb_phone"
                                    style={{
                                        textAlign: 'right'
                                    }}
                                />   
                                </div>                         
                            </div>
                        </td>
                    </tr>} */}
                                        
                    {inputArr?.find(item => item?.keys === '중도금')?.values?.map((x, i) => {
                        let rowspan = inputArr?.find(item => item?.keys === '중도금')?.values?.length;
                        let values = x?.values?.find(item => item?.keys === '중도금')?.values;
                        let values1 = x?.values?.find(item => item?.keys === '중도금지불일년')?.values;
                        let values2 = x?.values?.find(item => item?.keys === '중도금지불일월')?.values;
                        let values3 = x?.values?.find(item => item?.keys === '중도금지불일일')?.values;
                        let indexNumber = i;
                        return (
                            <tr>
                                {i === 0 &&
                                    <th className='justifys' colSpan={3} rowSpan={rowspan} >
                                        중 도 금<br />
                                        <div
                                            style={{
                                                display: 'flex', alignItems: 'center', justifyItems: 'center', flexDirection: 'row',
                                                marginTop: 5
                                            }}
                                        >
                                            <button
                                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '50%' }}
                                                onClick={() => {
                                                    let saveArr = [...inputArr?.find(item => item?.keys === '중도금')?.values];
                                                    saveArr.push({keys: "중도금"+rowspan, values: [
                                                        {keys: "중도금", values: '', requireCkr: true, errmsg: '두번째 중도금을 입력해주세요.'},
                                                        {keys: "중도금지불일년", values: moment().format('YYYY'), requireCkr: true, errmsg: '소재지를 입력해주세요.'},
                                                        {keys: "중도금지불일월", values: moment().format('MM'), requireCkr: true, errmsg: '소재지를 입력해주세요.'},
                                                        {keys: "중도금지불일일", values: moment().format('DD'), requireCkr: true, errmsg: '소재지를 입력해주세요.'},
                                                    ], requireCkr: true, errmsg: '중도금을 입력해주세요.'});
                                                    setinputArr(inputArr?.map((x, i) => {
                                                        if(x?.keys === '중도금'){
                                                            return {...x, values: saveArr}
                                                        } else {
                                                            return x;
                                                        }
                                                    }));

                                                }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" fill="#333333"/>
                                                </svg>
                                            </button>
                                            <button
                                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '50%' }}
                                                onClick={() => {
                                                    if(rowspan === 1) return;
                                                    let saveArr = [...inputArr?.find(item => item?.keys === '중도금')?.values?.filter((item, index) => index !== rowspan-1)];
                                                    setinputArr(inputArr?.map((x, i) => {
                                                        if(x?.keys === '중도금'){
                                                            return {...x, values: saveArr}
                                                        } else {
                                                            return x;
                                                        }
                                                    }));

                                                }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M5 11V13H19V11H5Z" fill="#333333"/>
                                                </svg>
                                            </button>
                                        </div>
                                    </th>
                                }
                                <td colSpan={27}>
                                    <div className='displayflexstart' style={{ gap: 4 }}>
                                        금 
                                        <div style={{ width: 160 }}>
                                        <Input 
                                            className={`inputs`}
                                            placeholder=""
                                            setValue={(e) => {
                                                datavaluesFunc('중도금', '중도금', indexNumber, e);
                                            }}
                                            value={values}
                                            name="mb_phone"
                                            style={{
                                                textAlign: 'right'
                                            }}
                                        />   
                                        </div>     
                                        만원은                      
                                        <Select 
                                            divwidth={{   width: 100 }}
                                            setValues={(e) => {
                                                datavaluesFunc('중도금', '중도금지불일년', indexNumber, e);
                                            }}
                                            values={values1}
                                            selectData={yearDatas}
                                        />년
                                        
                                        <Select 
                                            divwidth={{  width: 60 }}
                                            setValues={(e) => {
                                                datavaluesFunc('중도금', '중도금지불일월', indexNumber, e);
                                            }}
                                            values={values2}
                                            selectData={monthDatas}
                                        />월
                                        
                                        <Select 
                                            divwidth={{  width: 60 }}
                                            setValues={(e) => {
                                                console.log(inputArr);
                                                datavaluesFunc('중도금', '중도금지불일일', indexNumber, e);
                                            }}
                                            values={values3}
                                            selectData={dayDatas}
                                        />일    
                                        
                                        에 지불한다. ({rowspan}차중 {i+1}차)
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                    
                    <tr>
                        <th className='justifys' colSpan={3} >잔 금</th>
                        <td colSpan={27}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                금 
                                <div style={{ width: 160 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '잔금' ? {...item, values: e} : item));
                                    }}
                                    value={inputArr?.find(item => item?.keys === '잔금')?.values}
                                    name="mb_phone"
                                    style={{
                                        textAlign: 'right'
                                    }}
                                />   
                                </div>       
                                만원은                  
                                <Select 
                                    divwidth={{   width: 100 }}
                                    setValues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '잔금년' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '잔금년')?.values}
                                    selectData={yearDatas}
                                />년
                                <Select 
                                    divwidth={{  width: 60 }}
                                    setValues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '잔금월' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '잔금월')?.values}
                                    selectData={monthDatas}
                                />월
                                <Select 
                                    divwidth={{  width: 60 }}
                                    setValues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '잔금일' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '잔금일')?.values}
                                    selectData={dayDatas}
                                />일    
                                에 지불한다.
                            </div>
                        </td>
                    </tr>     
                    {sell_type === '월세' &&    
                    <tr>
                        <th className='justifys' colSpan={3} >차 임</th>
                        <td colSpan={27}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                금 
                                <div style={{ width: 160 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '차임' ? {...item, values: e} : item));
                                    }}
                                    value={inputArr?.find(item => item?.keys === '차임')?.values}
                                    name="mb_phone"
                                    style={{
                                        textAlign: 'right'
                                    }}
                                />   
                                </div>       
                                만원은 매월 
                                <Select 
                                    divwidth={{  width: 60 }}
                                    setValues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '차임일' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '차임일')?.values}
                                    selectData={dayDatas}
                                />일    
                                에 지불한다.
                            </div>
                        </td>
                    </tr> }               
                    <tr>
                        <td colSpan={30} className='contractmoreText'>
                            {sell_type === '매매' ?
                            <div>
                                <div>
                                    <p>제 2조</p>
                                    <p>
                                        <div>
                                        [소유권 이전 등] 매도인은 매매대금의 잔금 수령과 동시에 매수인에게 소유권이전등기에 필요한 모든 서류를 교부하고 등기절차에 협력하며, 위 부동산의 인도일은
                                        </div>
                                        <div>
                                            <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '부동산인도일년' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '부동산인도일년')?.values}
                                                selectData={yearDatas}
                                            />년
                                            <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}                                            
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '부동산인도일월' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '부동산인도일월')?.values}
                                                selectData={monthDatas}
                                            />월
                                            <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}                                            
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '부동산인도일일' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '부동산인도일일')?.values}
                                                selectData={dayDatas}
                                            />일 로 한다.
                                        </div>
                                    </p>
                                </div>
                                
                                <div>
                                    <p>제 3조</p>
                                    <p>[제한물권 등의 소멸] 매도인은 위의 부동산에 설정된 저당권, 지상권, 임차권 등 소유권의 행사를 제한하는 사유가 있거나, 제세공과 기타 부담금의 미납 등이 있을 때에는 잔금 수수일까지 그 권리의 하자 및 부담 등을 제거하여 완전한 소유권을 매수인에게 이전한다. 다만, 승계하기로 합의하는 권리 및 금액은 그러하지 아니하다.</p>
                                </div>
                                <div>
                                    <p>제 4조</p>
                                    <p>[지방세 등] 위 부동산에 관하여 발생한 수익의 귀속과 제세공과금 등의 부담은 위 부동산의 인도일을 기준으로 하되, 지방세의 납부의무 및 납부책임은 지방세법의 규정에 의한다.</p>
                                </div>
                                <div>
                                    <p>제 5조</p>
                                    <p>[계약의 해제] 매수인이 매도인에게 중도금(중도금이 없을 때에는 잔금)을 지급하기 전까지 매도인은 계약금의 배액을 상환하고, 매수인은 계약금을 포기하고 본 계약을 해제할 수 있다.</p>
                                </div>
                                <div>
                                    <p>제 6조</p>
                                    <p>[채무불이행과 손해배상의 예정] 매도인 또는 매수인은 본 계약상의 내용에 대하여 불이행이 있을 경우 그 상대방은 불이행 한 자에 대하여 서면으로 최고하고 계약을 해제할 수 있다. 그리고 계약 당사자는 계약해제에 따른 손해배상을 각각 상대방에게 청구할 수 있으며, 손해배상에 대하여 별도의 약정이 없는 한 계약금을 손해배상의 기준으로 본다.</p>
                                </div>
                                <div>
                                    <p>제 7조</p>
                                    <p>[중개보수] 개업공인중개사는 매도인 또는 매수인의 본 계약 불이행에 대하여 책임을 지지 않는다. 또한 중개보수는 본 계약 체결에 따라 계약 당사자 쌍방이 각각 지급하며, 개업공인중개사의 고의나 과실 없이 본 계약이 무효, 취소 또는 해제 되어도 중개보수는 지급한다. 공동중개인 경우에 매도인과 매수인은 자신이 의뢰한 개업공인중개사에게 각각 중개보수를 지급한다.</p>
                                </div>
                                <div>
                                    <p>제 8조</p>
                                    <p>[중개보수 외] 매도인 또는 매수인이 본 계약 이외의 업무를 의뢰한 경우, 이에 관한 보수는 중개수수료와는 별도로 지급하며 그 금액은 합의에 의한다.</p>
                                </div>
                                <div>
                                    <p style={{ paddingTop: 12 }}>제 9조</p>
                                    <p>
                                        <div>
                                        [중개대상물확인·설명서 교부 등] 개업공인중개사는 중개대상물 확인·설명서를 작성하고 업무보증관계증서(공제증서 등) 사본을 첨부하여 계약체결과 동시에 거래당사자 쌍방에게 교부한다.
                                        </div>
                                        <div>
                                            (교부일자
                                            <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}  
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '쌍방교부년' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '쌍방교부년')?.values}
                                                selectData={yearDatas}
                                            />년
                                            <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}  
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '쌍방교부월' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '쌍방교부월')?.values}
                                                selectData={monthDatas}
                                            />월
                                            <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}  
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '쌍방교부일' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '쌍방교부일')?.values}
                                                selectData={dayDatas}
                                            />일                                  
                                            )
                                        </div>
                                    </p>

                                </div>
                            </div>
                            :   
                            <div>
                                <div>
                                    <p>제 2조</p>
                                    <p>
                                        <div>
                                            [존속기간] 임대인은 위 부동산을 임대차 목적대로 사용할 수 있는 상태로 
                                            <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '부동산인도일년' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '부동산인도일년')?.values}
                                                selectData={yearDatas}
                                            />년
                                            <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}                                            
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '부동산인도일월' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '부동산인도일월')?.values}
                                                selectData={monthDatas}
                                            />월
                                            <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}                                            
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '부동산인도일일' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '부동산인도일일')?.values}
                                                selectData={dayDatas}
                                            />일                                             
                                            
                                        </div>
                                        <div>
                                            까지 임차인에게 인도하며, 임대차 기간은 인도일로부터 <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '부동산임대차인도일년' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '부동산임대차인도일년')?.values}
                                                selectData={yearDatas}
                                            />년
                                            <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}                                            
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '부동산임대차인도일월' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '부동산임대차인도일월')?.values}
                                                selectData={monthDatas}
                                            />월
                                            <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}                                            
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '부동산임대차인도일일' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '부동산임대차인도일일')?.values}
                                                selectData={dayDatas}
                                            />일
                                        </div>
                                        <div>
                                            (
                                            <div style={{ width: 80}}>
                                            <Input 
                                                className={`inputs`}
                                                setValue={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '부동산임대차인도일개월' ? {...item, values: e} : item));
                                                }}
                                                value={inputArr?.find(item => item?.keys === '부동산임대차인도일개월')?.values}
                                                name="mb_phone"
                                                style={{
                                                    textAlign: 'right', 
                                                }}
                                            /></div>
                                                개월)까지로 한다.
                                        </div>
                                    </p>
                                </div>
                                <div>
                                    <p>제 3조</p>
                                    <p>[용도변경 및 전대 등] 임차인은 임대인의 동의 없이 위 부동산의 용도나 구조를 변경하거나 전대, 임차권 양도 또는 담보제공을 하지 못하며 임대차 목적 이외의 용도로 사용할 수 없다.</p>
                                </div>
                                <div>
                                    <p>제 4조</p>
                                    <p>[계약의 해지] 임대인은 임차인이 2기의 차임액에 달하도록 연체하거나, 제3조를 위반하였을 즉시 본 계약을 해지할 수 있다.</p>
                                </div>
                                <div>
                                    <p>제 5조</p>
                                    <p>[계약의 종료] 임대차계약이 종료된 경우 임차인은 위 부동산을 원상으로 회복하여 임대인에게 반환한다. 이러한 경우 임대인은 보증금을 임차인에게 반환하고, 연체 임대료 또는 손해배상금이 있을 때는 이들을 제하고 그 잔액을 반환한다.</p>
                                </div>
                                <div>
                                    <p>제 6조</p>
                                    <p>[계약의 해제] 임차인이 임대인에게 중도금(중도금이 없을 때는 잔금)을 지급하기 전까지 임대인은 계약금의 배액을 상환하고, 임차인은 계약금을 포기하고 이 계약을 해제할 수 있다.</p>
                                </div>
                                <div>
                                    <p>제 7조</p>
                                    <p>[채무불이행과 손해배상의 예정] 임대인 또는 임차인은 본 계약상의 내용에 대하여 불이행이 있을 경우 그 상대방은 불이행 한 자에 대하여 서면으로 최고하고 계약을 해제할 수 있다. 이 경우 계약 당사자는 계약해제에 따른 손해배상을 각각 상대방에게 청구할 수 있으며, 손해배상에 대하여 별도의 약정이 없는 한 계약금을 손해배상의 기준으로 본다.</p>
                                </div>
                                <div>
                                    <p>제 8조</p>
                                    <p>[중개보수] 개업공인중개사는 임대인 또는 임차인의 본 계약 불이행에 대하여 책임을 지지 않는다. 또한 중개보수는 본 계약 체결에 따라 계약 당사자 쌍방이 각각 지급하며, 개업공인중개사의 고의나 과실 없이 본 계약이 무효, 취소 또는 해제 되어도 중개보수는 지급한다. 공동중개인 경우에 임대인과 임차인은 자신이 중개 의뢰한 개업공인중개사에게 각각 중개보수를 지급한다.</p>
                                </div>                                
                                <div>
                                    <p style={{ paddingTop: 12 }}>제 9조</p>
                                    <p>
                                        <div>
                                        [중개대상물확인·설명서 교부 등] 개업공인중개사는 중개대상물 확인·설명서를 작성하고 업무보증관계증서(공제증서 등) 사본을 첨부하여 계약체결과 동시에 거래당사자 쌍방에게 교부한다.
                                        </div>
                                        <div>
                                            (교부일자:
                                            <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}  
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '쌍방교부년' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '쌍방교부년')?.values}
                                                selectData={yearDatas}
                                            />년
                                            <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}  
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '쌍방교부월' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '쌍방교부월')?.values}
                                                selectData={monthDatas}
                                            />월
                                            <Select 
                                                divwidth={{  height: 30 }}
                                                styles={{ height: 30 }}  
                                                setValues={(e) => {
                                                    setinputArr(inputArr?.map(item => item?.keys === '쌍방교부일' ? {...item, values: e} : item));
                                                }}
                                                values={inputArr?.find(item => item?.keys === '쌍방교부일')?.values}
                                                selectData={dayDatas}
                                            />일 )
                                        </div>
                                    </p>

                                </div>
                            </div>
                            }
                        </td>
                    </tr>
                    {/* {keys: "특약사항", values: [
                        {keys: "특약사항", values: '', requireCkr: false, errmsg: '소재지를 입력해주세요.'},
                    ], requireCkr: false, errmsg: '특약사항을 입력해주세요.'}, */}
                    {inputArr?.find(item => item?.keys === '특약사항')?.values?.map((x, i) => {
                        let rowspan = inputArr?.find(item => item?.keys === '특약사항')?.values?.length;
                        let indexNumber = i;
                        return (
                            <tr>
                                <td colSpan={30} style={{ padding: 0 }}>
                                    <div
                                        style={{
                                            display: 'flex', alignItems: 'center', justifyItems: 'flex-start', flexDirection: 'row'
                                        }}
                                    >
                                        {i === 0 ?
                                        <p style={{ padding: '10px 10px 0px', fontSize: 12  }}>특약사항(최대 19줄)</p>
                                        :
                                        <p style={{ padding: '10px 10px 0px', fontSize: 12  }}>특약사항(최대 20줄)</p>
                                        }
                                        {rowspan-1 === i &&
                                        <>
                                        <button
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}
                                            onClick={() => {
                                                let saveArr = [...inputArr?.find(item => item?.keys === '특약사항')?.values];
                                                saveArr.push({keys: "특약사항"+rowspan, values: '', requireCkr: false, errmsg: '소재지를 입력해주세요.'});
                                                setinputArr(inputArr?.map((x, i) => {
                                                    if(x?.keys === '특약사항'){
                                                        return {...x, values: saveArr}
                                                    } else {
                                                        return x;
                                                    }
                                                }));

                                            }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" fill="#333333"/>
                                            </svg>
                                        </button>
                                        
                                        <button
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}
                                            onClick={() => {
                                                if(rowspan === 1) return;
                                                let saveArr = [...inputArr?.find(item => item?.keys === '특약사항')?.values?.filter((item, index) => index !== rowspan-1)];
                                                setinputArr(inputArr?.map((x, i) => {
                                                    if(x?.keys === '특약사항'){
                                                        return {...x, values: saveArr}
                                                    } else {
                                                        return x;
                                                    }
                                                }));

                                            }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M5 11V13H19V11H5Z" fill="#333333"/>
                                            </svg>
                                        </button>
                                        </>
                                        }
                                    </div>
                                    <textarea 
                                        className='contractTextarea' 
                                        onChange={(e) => {

                                            var rows = e.target.value.split('\n').length;
                                            var maxRows = i === 0 ? 19 : 20;
                                            if( rows > maxRows){
                                                return;
                                            }

                                            setinputArr(inputArr?.map((x, i) => {
                                                if(x?.keys === '특약사항'){
                                                    return {...x, values: x?.values?.map((x2, i2) => {
                                                        if(i2 === indexNumber){
                                                            return {...x2, values: e.target.value};
                                                        } else {
                                                            return x2;
                                                        }
                                                    })}
                                                } else {
                                                    return x;
                                                }
                                            }));                                            
                                        }}
                                        value={x?.values}
                                    ></textarea>
                                </td>
                            </tr>
                        );
                    })}

                    <tr>
                        <td colSpan={30} >
                            <div
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 20 }}
                            >
                                <div className='fontsize12'>
                                    본 계약을 증명하기 위하여 계약 당사자가 이의 없음을 확인하고 각각 서명 또는 날인한다.
                                </div>
                                <div
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}
                                >
                                    <div
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, width: 100 }}
                                    >
                                        <Select 
                                            divwidth={{  height: 30 }}
                                            styles={{ height: 30 }}  
                                            setValues={(e) => {
                                                setinputArr(inputArr?.map(item => item?.keys === '날인일년' ? {...item, values: e} : item));
                                            }}
                                            values={inputArr?.find(item => item?.keys === '날인일년')?.values}
                                            selectData={yearDatas}
                                        />년
                                    </div>
                                    <div
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, width: 80}}
                                    >                                    
                                    <Select 
                                        divwidth={{  height: 30 }}
                                        styles={{ height: 30 }}  
                                        setValues={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '날인일월' ? {...item, values: e} : item));
                                        }}
                                        values={inputArr?.find(item => item?.keys === '날인일월')?.values}
                                        selectData={monthDatas}
                                    />월
                                    </div>
                                    <div
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, width: 80}}
                                    >                                    
                                    <Select 
                                        divwidth={{  height: 30 }}
                                        styles={{ height: 30 }}  
                                        setValues={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '날인일' ? {...item, values: e} : item));
                                        }}
                                        values={inputArr?.find(item => item?.keys === '날인일')?.values}
                                        selectData={dayDatas}
                                    />일        
                                    </div>                                        
                                </div>
                            </div>
                        </td>
                    </tr>

                    {inputArr?.find(item => item?.keys === '매도인')?.values?.map((x, i) => {
                        let rowspan = inputArr?.find(item => item?.keys === '매도인')?.values?.length;
                        let indexNumber = i;
                        return (
                            <>
                            <tr>
                                <th className='justifys' colSpan={4} rowSpan={2}>
                                    {sell_type === '매매' ? '매 도 인' : '임 대 인'}
                                    <div
                                        style={{ 
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, flexDirection: 'row', width: '100%',
                                            marginTop: 5
                                        }}
                                    >
                                        {rowspan-1 === i &&
                                        <>
                                        <button
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '20%' }}
                                            onClick={() => {
                                                let saveArr = [...inputArr?.find(item => item?.keys === '매도인')?.values];
                                                saveArr.push({keys: "매도인"+rowspan, values: [
                                                    {keys: "매도인주소", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "매도인주민번호선택", values: '주민등록번호', requireCkr: false, errmsg: ''},
                                                    {keys: "매도인주민번호", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "매도인전화", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "매도인성명", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "대리인", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "대리인주소", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "대리인주민번호선택", values: '주민등록번호', requireCkr: false, errmsg: ''},
                                                    {keys: "대리인주민번호", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "대리인전화", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "대리인성명", values: '', requireCkr: false, errmsg: ''},
                                                ], requireCkr: false, subflag: false,  errmsg: ''});
                                                setinputArr(inputArr?.map((x, i) => {
                                                    if(x?.keys === '매도인'){
                                                        return {...x, values: saveArr}
                                                    } else {
                                                        return x;
                                                    }
                                                }));

                                            }}
                                        >
                                            <img src="./images/icons/addplus.svg" width='16' />
                                        </button>
                                        {i > 0 &&
                                        <button
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '20%' }}
                                            onClick={() => {
                                                if(rowspan === 1) return;
                                                let saveArr = [...inputArr?.find(item => item?.keys === '매도인')?.values?.filter((item, index) => index !== rowspan-1)];
                                                setinputArr(inputArr?.map((x, i) => {
                                                    if(x?.keys === '매도인'){
                                                        return {...x, values: saveArr}
                                                    } else {
                                                        return x;
                                                    }
                                                }));

                                            }}
                                        >
                                            <img src="./images/icons/adddelete.svg" width='16' />
                                        </button>
                                        }
                                        </>}    

                                        {x?.subflag === false &&
                                            <button
                                                style={{ 
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center', width: 55, height: 19,
                                                    fontSize: 9, backgroundColor: '#D4D4D4', borderRadius: 5, color: '#555555'
                                                }}
                                                onClick={() => {
                                                    setinputArr([...inputArr?.map((x, i) => {
                                                        if(x?.keys === '매도인'){
                                                            return {...x, values: x?.values?.map((x2, i2) => {
                                                                if(i2 === indexNumber){
                                                                    return {...x2, subflag: !x2?.subflag}
                                                                } else {
                                                                    return x2;
                                                                }
                                                            })}
                                                        } else {
                                                            return x;
                                                        }
                                                    })]); 

                                                }}
                                            >
                                                관계인추가
                                            </button>                                    
                                        }                                                                            
                                    </div>
                                </th>
                                <th className='justifys' colSpan={6} >
                                    주 소<br />
                                    <div
                                        style={{
                                            display: 'flex', alignItems: 'center', justifyItems: 'center', flexDirection: 'row',
                                            marginTop: 0,
                                        }}
                                    >
                                    </div>   
                                </th>
                                <td colSpan={18}>
                                    <div className='buttonWithTxt' style={{ marginTop: 0 }}>
                                        <div>
                                            <Button
                                                className={'normalbutton_middle'}
                                                buttonTxt={'주소찾기'}
                                                onPress={() => {
                                                    addropennerFunc('매도인', '매도인주소', indexNumber, true) 
                                                }}
                                            />
                                        </div>
                                        <div style={{ width: 'calc(100% - 100px)'}}>
                                            <Input 
                                                className={`inputs`}
                                                setValue={(e) => {
                                                    datavaluesFunc('매도인', '매도인주소', indexNumber, e);
                                                }}
                                                value={x?.values?.find(item => item?.keys === '매도인주소')?.values}
                                                name="mb_phone"
                                            /> 
                                        </div>
                                    </div>
                                    {x?.values?.find(item => item?.keys === '매도인주소')?.requireCkr ? (
                                        <div style={postBoxStyle}>
                                            <button type="button" className="addrbtn exit_btn" onClick={() => addropennerFunc('매도인', '매도인주소', indexNumber, false)} style={{ padding: 10 }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.79289C5.68342 5.40237 6.31658 5.40237 6.70711 5.79289L12 11.0858L17.2929 5.79289C17.6834 5.40237 18.3166 5.40237 18.7071 5.79289C19.0976 6.18342 19.0976 6.81658 18.7071 7.20711L13.4142 12.5L18.7071 17.7929C19.0976 18.1834 19.0976 18.8166 18.7071 19.2071C18.3166 19.5976 17.6834 19.5976 17.2929 19.2071L12 13.9142L6.70711 19.2071C6.31658 19.5976 5.68342 19.5976 5.29289 19.2071C4.90237 18.8166 4.90237 18.1834 5.29289 17.7929L10.5858 12.5L5.29289 7.20711C4.90237 6.81658 4.90237 6.18342 5.29289 5.79289Z" fill="#999999"/>
                                                </svg>                            
                                            </button>
                                            <DaumPostcode style={postCodeStyle} autoClose onComplete={(data) => addrvaluesFunc('매도인', '매도인주소', indexNumber, data)} />
                                        </div>
                                    ) : null}                               
                                </td>
                                <td colSpan={2} rowSpan={2} style={{ textAlign: 'center' }}>
                                    (인)
                                </td>
                            </tr>
                            <tr>
                                <th className='justifys' colSpan={6} >
                                    <Select 
                                        divwidth={{  height: 30 }}
                                        styles={{ height: 30 }}  
                                        setValues={(e) => {
                                            if(e === '주민등록번호'){
                                                datavaluesFunc('매도인', '매도인주민번호', indexNumber, x?.values?.find(item => item?.keys === '매도인주민번호')?.values?.substr(0,6));
                                            }
                                            datavaluesFunc('매도인', '매도인주민번호선택', indexNumber, e);
                                        }}
                                        values={x?.values?.find(item => item?.keys === '매도인주민번호선택')?.values}
                                        selectData={[
                                            {labels: '주민등록번호', values: '주민등록번호'},
                                            {labels: '법인등록번호', values: '법인등록번호'},
                                            {labels: '외국인등록번호', values: '외국인등록번호'},
                                            {labels: '기타단체등록번호', values: '기타단체등록번호'},
                                            {labels: '제외국민주민번호', values: '제외국민주민번호'},
                                            {labels: '사업자등록번호', values: '사업자등록번호'},
                                            {labels: '종교단체등록번호', values: '종교단체등록번호'},
                                            {labels: '여권번호', values: '여권번호'},
                                            {labels: '고유등록번호', values: '고유등록번호'},
                                        ]}
                                    />
                                </th>
                                <td colSpan={5}>
                                    <Input 
                                        className={`inputs`}
                                        setValue={(e) => {
                                            // if(x?.values?.find(item => item?.keys === '매도인주민번호선택')?.values === '주민등록번호'){
                                            //     if(e?.length > 6){
                                            //         return;
                                            //     }
                                            // }
                                            datavaluesFunc('매도인', '매도인주민번호', indexNumber, e);
                                        }}
                                        value={x?.values?.find(item => item?.keys === '매도인주민번호')?.values}
                                        name="mb_phone"
                                    />
                                </td>
                                <th className='justifys' colSpan={2} >전 화</th>
                                <td colSpan={5}>
                                    <Input 
                                        className={`inputs`}
                                        setValue={(e) => {
                                            datavaluesFunc('매도인', '매도인전화', indexNumber, e);
                                        }}
                                        value={x?.values?.find(item => item?.keys === '매도인전화')?.values}
                                        name="mb_phone"
                                    />
                                </td>
                                <th className='justifys' colSpan={2} >성 명</th>
                                <td colSpan={4}>
                                    <Input 
                                        className={`inputs`}
                                        setValue={(e) => {
                                            datavaluesFunc('매도인', '매도인성명', indexNumber, e);
                                        }}
                                        value={x?.values?.find(item => item?.keys === '매도인성명')?.values}
                                        name="mb_phone"
                                    />
                                </td>
                            </tr>               
                            {x?.subflag === true &&
                            <>
                                <tr>
                                    <th className='justifys' colSpan={4} rowSpan={2}>
                                        <Input 
                                            className={`inputs`}
                                            setValue={(e) => {
                                                datavaluesFunc('매도인', '대리인', indexNumber, e);
                                            }}
                                            value={x?.values?.find(item => item?.keys === '대리인')?.values}
                                            name="mb_phone"
                                        />
                                        <button
                                            style={{ 
                                                display: 'flex', alignItems: 'center', justifyContent: 'center', width: 55, height: 19,
                                                fontSize: 10, backgroundColor: '#D4D4D4', borderRadius: 5, color: '#555555', marginTop: 5
                                            }}
                                            onClick={() => {
                                                setinputArr([...inputArr?.map((x, i) => {
                                                    if(x?.keys === '매도인'){
                                                        return {...x, values: x?.values?.map((x2, i2) => {
                                                            if(i2 === indexNumber){
                                                                return {...x2, subflag: !x2?.subflag}
                                                            } else {
                                                                return x2;
                                                            }
                                                        })}
                                                    } else {
                                                        return x;
                                                    }
                                                })]); 

                                            }}
                                        >
                                            관계인 삭제
                                        </button>    
                                    </th>
                                    <th className='justifys' colSpan={6} >
                                        주 소
                                    </th>
                                    <td colSpan={18}>
                                        <div className='buttonWithTxt' style={{ marginTop: 0 }}>
                                            <div>
                                                <Button
                                                    className={'normalbutton_middle'}
                                                    buttonTxt={'주소찾기'}
                                                    onPress={() => {
                                                        addropennerFunc('매도인', '대리인주소', indexNumber, true) 
                                                    }}
                                                />
                                            </div>
                                            <div style={{ width: 'calc(100% - 100px)'}}>
                                                <Input 
                                                    className={`inputs`}
                                                    setValue={(e) => {
                                                        datavaluesFunc('매도인', '대리인주소', indexNumber, e);
                                                    }}
                                                    value={x?.values?.find(item => item?.keys === '대리인주소')?.values}
                                                    name="mb_phone"
                                                /> 
                                            </div>
                                        </div>
                                        {x?.values?.find(item => item?.keys === '대리인주소')?.requireCkr ? (
                                            <div style={postBoxStyle}>
                                                <button type="button" className="addrbtn exit_btn" onClick={() => addropennerFunc('대리인', '대리인주소', indexNumber, false)} style={{ padding: 10 }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.79289C5.68342 5.40237 6.31658 5.40237 6.70711 5.79289L12 11.0858L17.2929 5.79289C17.6834 5.40237 18.3166 5.40237 18.7071 5.79289C19.0976 6.18342 19.0976 6.81658 18.7071 7.20711L13.4142 12.5L18.7071 17.7929C19.0976 18.1834 19.0976 18.8166 18.7071 19.2071C18.3166 19.5976 17.6834 19.5976 17.2929 19.2071L12 13.9142L6.70711 19.2071C6.31658 19.5976 5.68342 19.5976 5.29289 19.2071C4.90237 18.8166 4.90237 18.1834 5.29289 17.7929L10.5858 12.5L5.29289 7.20711C4.90237 6.81658 4.90237 6.18342 5.29289 5.79289Z" fill="#999999"/>
                                                    </svg>                            
                                                </button>
                                                <DaumPostcode style={postCodeStyle} autoClose onComplete={(data) => addrvaluesFunc('매도인', '대리인주소', indexNumber, data)} />
                                            </div>
                                        ) : null}                               
                                    </td>
                                    <td colSpan={2} rowSpan={2} style={{ textAlign: 'center' }}>
                                        (인)
                                    </td>
                                </tr>
                                <tr>
                                    <th className='justifys' colSpan={6} >
                                        <Select 
                                            divwidth={{  height: 30 }}
                                            styles={{ height: 30 }}  
                                            setValues={(e) => {
                                                datavaluesFunc('매도인', '대리인주민번호선택', indexNumber, e);
                                            }}
                                            values={x?.values?.find(item => item?.keys === '대리인주민번호선택')?.values}
                                            selectData={[
                                                {labels: '주민등록번호', values: '주민등록번호'},
                                                {labels: '법인등록번호', values: '법인등록번호'},
                                                {labels: '외국인등록번호', values: '외국인등록번호'},
                                                {labels: '기타단체등록번호', values: '기타단체등록번호'},
                                                {labels: '제외국민주민번호', values: '제외국민주민번호'},
                                                {labels: '사업자등록번호', values: '사업자등록번호'},
                                                {labels: '종교단체등록번호', values: '종교단체등록번호'},
                                                {labels: '여권번호', values: '여권번호'},
                                                {labels: '고유등록번호', values: '고유등록번호'},
                                            ]}
                                        />
                                    </th>
                                    <td colSpan={5}>
                                        <Input 
                                            className={`inputs`}
                                            setValue={(e) => {
                                                datavaluesFunc('매도인', '대리인주민번호', indexNumber, e);
                                            }}
                                            value={x?.values?.find(item => item?.keys === '대리인주민번호')?.values}
                                            name="mb_phone"
                                        />
                                    </td>
                                    <th className='justifys' colSpan={2} >전 화</th>
                                    <td colSpan={5}>
                                        <Input 
                                            className={`inputs`}
                                            setValue={(e) => {
                                                datavaluesFunc('매도인', '대리인전화', indexNumber, e);
                                            }}
                                            value={x?.values?.find(item => item?.keys === '대리인전화')?.values}
                                            name="mb_phone"
                                        />
                                    </td>
                                    <th className='justifys' colSpan={2} >성 명</th>
                                    <td colSpan={4}>
                                        <Input 
                                            className={`inputs`}
                                            setValue={(e) => {
                                                datavaluesFunc('매도인', '대리인성명', indexNumber, e);
                                            }}
                                            value={x?.values?.find(item => item?.keys === '대리인성명')?.values}
                                            name="mb_phone"
                                        />
                                    </td>
                                </tr> 
                            </>
                            }


                            </>
                        );
                    })}
                    <tr>
                        <td colSpan={30} style={{ height: 30 }}></td>
                    </tr>
                    {inputArr?.find(item => item?.keys === '매수인')?.values?.map((x, i) => {
                        let rowspan = inputArr?.find(item => item?.keys === '매수인')?.values?.length;
                        let indexNumber = i;
                        return (
                            <>
                            <tr>
                                <th className='justifys' colSpan={4} rowSpan={2}>
                                    {sell_type === '매매' ? '매 수 인' : '임 차 인'}
                                    <div
                                        style={{ 
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, flexDirection: 'row', width: '100%',
                                            marginTop: 5
                                        }}
                                    >
                                        {rowspan-1 === i &&
                                        <>
                                        <button
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '20%' }}
                                            onClick={() => {
                                                let saveArr = [...inputArr?.find(item => item?.keys === '매수인')?.values];
                                                saveArr.push({keys: "매수인"+rowspan, values: [
                                                    {keys: "매수인주소", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "매수인주민번호선택", values: '주민등록번호', requireCkr: false, errmsg: ''},
                                                    {keys: "매수인주민번호", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "매수인전화", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "매수인성명", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "대리인", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "대리인주소", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "대리인주민번호선택", values: '주민등록번호', requireCkr: false, errmsg: ''},
                                                    {keys: "대리인주민번호", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "대리인전화", values: '', requireCkr: false, errmsg: ''},
                                                    {keys: "대리인성명", values: '', requireCkr: false, errmsg: ''},
                                                ], requireCkr: false, subflag: false, errmsg: ''});
                                                setinputArr(inputArr?.map((x, i) => {
                                                    if(x?.keys === '매수인'){
                                                        return {...x, values: saveArr}
                                                    } else {
                                                        return x;
                                                    }
                                                }));

                                            }}
                                        >
                                            <img src="./images/icons/addplus.svg" width='16' />
                                        </button>
                                        {i > 0 &&
                                        <button
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '20%' }}
                                            onClick={() => {
                                                if(rowspan === 1) return;
                                                let saveArr = [...inputArr?.find(item => item?.keys === '매수인')?.values?.filter((item, index) => index !== rowspan-1)];
                                                setinputArr(inputArr?.map((x, i) => {
                                                    if(x?.keys === '매수인'){
                                                        return {...x, values: saveArr}
                                                    } else {
                                                        return x;
                                                    }
                                                }));

                                            }}
                                        >
                                            <img src="./images/icons/adddelete.svg" width='16' />
                                        </button>
                                        }
                                        </>}    

                                        {x?.subflag === false &&
                                            <button
                                                style={{ 
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center', width: 55, height: 19,
                                                    fontSize: 9, backgroundColor: '#D4D4D4', borderRadius: 5, color: '#555555'
                                                }}
                                                onClick={() => {
                                                    setinputArr(inputArr?.map((x, i) => {
                                                        if(x?.keys === '매수인'){
                                                            return {...x, values: x?.values?.map((x2, i2) => {
                                                                if(i2 === indexNumber){
                                                                    return {...x2, subflag: !x2?.subflag}
                                                                } else {
                                                                    return x2;
                                                                }
                                                                
                                                            })}
                                                        } else {
                                                            return x;
                                                        }
                                                    })); 

                                                }}
                                            >
                                                관계인추가
                                            </button>                                    
                                        }                                          
                                    </div>
                                </th>
                                <th className='justifys' colSpan={6} >
                                    주 소<br />
                                </th>
                                <td colSpan={18}>
                                    <div className='buttonWithTxt' style={{ marginTop: 0 }}>
                                        <div>
                                            <Button
                                                className={'normalbutton_middle'}
                                                buttonTxt={'주소찾기'}
                                                onPress={() => {
                                                    addropennerFunc('매수인', '매수인주소', indexNumber, true) 
                                                }}
                                            />
                                        </div>
                                        <div style={{ width: 'calc(100% - 100px)'}}>
                                            <Input 
                                                className={`inputs`}
                                                setValue={(e) => {
                                                    datavaluesFunc('매수인', '매수인주소', indexNumber, e);
                                                }}
                                                value={x?.values?.find(item => item?.keys === '매수인주소')?.values}
                                                name="mb_phone"
                                            /> 
                                        </div>
                                    </div>
                                    {x?.values?.find(item => item?.keys === '매수인주소')?.requireCkr ? (
                                        <div style={postBoxStyle}>
                                            <button type="button" className="addrbtn exit_btn" onClick={() => addropennerFunc('매수인', '매수인주소', indexNumber, false)} style={{ padding: 10 }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.79289C5.68342 5.40237 6.31658 5.40237 6.70711 5.79289L12 11.0858L17.2929 5.79289C17.6834 5.40237 18.3166 5.40237 18.7071 5.79289C19.0976 6.18342 19.0976 6.81658 18.7071 7.20711L13.4142 12.5L18.7071 17.7929C19.0976 18.1834 19.0976 18.8166 18.7071 19.2071C18.3166 19.5976 17.6834 19.5976 17.2929 19.2071L12 13.9142L6.70711 19.2071C6.31658 19.5976 5.68342 19.5976 5.29289 19.2071C4.90237 18.8166 4.90237 18.1834 5.29289 17.7929L10.5858 12.5L5.29289 7.20711C4.90237 6.81658 4.90237 6.18342 5.29289 5.79289Z" fill="#999999"/>
                                                </svg>                            
                                            </button>
                                            <DaumPostcode style={postCodeStyle} autoClose onComplete={(data) => addrvaluesFunc('매수인', '매수인주소', indexNumber, data)} />
                                        </div>
                                    ) : null}                               
                                </td>
                                <td colSpan={2} rowSpan={2} style={{ textAlign: 'center' }}>
                                    (인)
                                </td>
                            </tr>
                            <tr>
                                <th className='justifys' colSpan={6} >
                                    <Select 
                                        divwidth={{  height: 30 }}
                                        styles={{ height: 30 }}  
                                        setValues={(e) => {
                                            datavaluesFunc('매수인', '매수인주민번호선택', indexNumber, e);
                                        }}
                                        values={x?.values?.find(item => item?.keys === '매수인주민번호선택')?.values}
                                        selectData={[
                                            {labels: '주민등록번호', values: '주민등록번호'},
                                            {labels: '법인등록번호', values: '법인등록번호'},
                                            {labels: '외국인등록번호', values: '외국인등록번호'},
                                            {labels: '기타단체등록번호', values: '기타단체등록번호'},
                                            {labels: '제외국민주민번호', values: '제외국민주민번호'},
                                            {labels: '사업자등록번호', values: '사업자등록번호'},
                                            {labels: '종교단체등록번호', values: '종교단체등록번호'},
                                            {labels: '여권번호', values: '여권번호'},
                                            {labels: '고유등록번호', values: '고유등록번호'},
                                        ]}
                                    />
                                </th>
                                <td colSpan={5}>
                                    <Input 
                                        className={`inputs`}
                                        setValue={(e) => {
                                            // if(x?.values?.find(item => item?.keys === '매수인주민번호선택')?.values === '주민등록번호'){
                                            //     if(e?.length > 6){
                                            //         return;
                                            //     }
                                            // }
                                            datavaluesFunc('매수인', '매수인주민번호', indexNumber, e);
                                        }}
                                        value={x?.values?.find(item => item?.keys === '매수인주민번호')?.values}
                                        name="mb_phone"
                                    />
                                </td>
                                <th className='justifys' colSpan={2} >전 화</th>
                                <td colSpan={5}>
                                    <Input 
                                        className={`inputs`}
                                        setValue={(e) => {
                                            datavaluesFunc('매수인', '매수인전화', indexNumber, e);
                                        }}
                                        value={x?.values?.find(item => item?.keys === '매수인전화')?.values}
                                        name="mb_phone"
                                    />
                                </td>
                                <th className='justifys' colSpan={2} >성 명</th>
                                <td colSpan={4}>
                                    <Input 
                                        className={`inputs`}
                                        setValue={(e) => {
                                            datavaluesFunc('매수인', '매수인성명', indexNumber, e);
                                        }}
                                        value={x?.values?.find(item => item?.keys === '매수인성명')?.values}
                                        name="mb_phone"
                                    />
                                </td>
                            </tr>               
                            {x?.subflag === true &&
                            <>
                                <tr>
                                    <th className='justifys' colSpan={4} rowSpan={2}>
                                        <Input 
                                            className={`inputs`}
                                            setValue={(e) => {
                                                datavaluesFunc('매수인', '대리인', indexNumber, e);
                                            }}
                                            value={x?.values?.find(item => item?.keys === '대리인')?.values}
                                            name="mb_phone"
                                        />
                                        <button
                                            style={{ 
                                                display: 'flex', alignItems: 'center', justifyContent: 'center', width: 55, height: 19,
                                                fontSize: 10, backgroundColor: '#D4D4D4', borderRadius: 5, color: '#555555', marginTop: 5
                                            }}
                                            onClick={() => {
                                                setinputArr(inputArr?.map((x, i) => {
                                                    if(x?.keys === '매수인'){
                                                        return {...x, values: x?.values?.map((x2, i2) => {
                                                            if(i2 === indexNumber){
                                                                return {...x2, subflag: !x2?.subflag}
                                                            } else {
                                                                return x2;
                                                            }
                                                            
                                                        })}
                                                    } else {
                                                        return x;
                                                    }
                                                })); 


                                            }}
                                        >
                                            관계인 삭제
                                        </button>                                            
                                    </th>
                                    <th className='justifys' colSpan={6} >
                                        주 소
                                    </th>
                                    <td colSpan={18}>
                                        <div className='buttonWithTxt' style={{ marginTop: 0 }}>
                                            <div>
                                                <Button
                                                    className={'normalbutton_middle'}
                                                    buttonTxt={'주소찾기'}
                                                    onPress={() => {
                                                        addropennerFunc('매수인', '대리인주소', indexNumber, true) 
                                                    }}
                                                />
                                            </div>
                                            <div style={{ width: 'calc(100% - 100px)'}}>
                                                <Input 
                                                    className={`inputs`}
                                                    setValue={(e) => {
                                                        datavaluesFunc('매수인', '대리인주소', indexNumber, e);
                                                    }}
                                                    value={x?.values?.find(item => item?.keys === '대리인주소')?.values}
                                                    name="mb_phone"
                                                /> 
                                            </div>
                                        </div>
                                        {x?.values?.find(item => item?.keys === '대리인주소')?.requireCkr ? (
                                            <div style={postBoxStyle}>
                                                <button type="button" className="addrbtn exit_btn" onClick={() => addropennerFunc('대리인', '대리인주소', indexNumber, false)} style={{ padding: 10 }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.79289C5.68342 5.40237 6.31658 5.40237 6.70711 5.79289L12 11.0858L17.2929 5.79289C17.6834 5.40237 18.3166 5.40237 18.7071 5.79289C19.0976 6.18342 19.0976 6.81658 18.7071 7.20711L13.4142 12.5L18.7071 17.7929C19.0976 18.1834 19.0976 18.8166 18.7071 19.2071C18.3166 19.5976 17.6834 19.5976 17.2929 19.2071L12 13.9142L6.70711 19.2071C6.31658 19.5976 5.68342 19.5976 5.29289 19.2071C4.90237 18.8166 4.90237 18.1834 5.29289 17.7929L10.5858 12.5L5.29289 7.20711C4.90237 6.81658 4.90237 6.18342 5.29289 5.79289Z" fill="#999999"/>
                                                    </svg>                            
                                                </button>
                                                <DaumPostcode style={postCodeStyle} autoClose onComplete={(data) => addrvaluesFunc('매수인', '대리인주소', indexNumber, data)} />
                                            </div>
                                        ) : null}                               
                                    </td>
                                    <td colSpan={2} rowSpan={2} style={{ textAlign: 'center' }}>
                                        (인)
                                    </td>
                                </tr>
                                <tr>
                                    <th className='justifys' colSpan={6} >
                                        <Select 
                                            divwidth={{  height: 30 }}
                                            styles={{ height: 30 }}  
                                            setValues={(e) => {
                                                datavaluesFunc('매수인', '대리인주민번호선택', indexNumber, e);
                                            }}
                                            values={x?.values?.find(item => item?.keys === '대리인주민번호선택')?.values}
                                            selectData={[
                                                {labels: '주민등록번호', values: '주민등록번호'},
                                                {labels: '법인등록번호', values: '법인등록번호'},
                                                {labels: '외국인등록번호', values: '외국인등록번호'},
                                                {labels: '기타단체등록번호', values: '기타단체등록번호'},
                                                {labels: '제외국민주민번호', values: '제외국민주민번호'},
                                                {labels: '사업자등록번호', values: '사업자등록번호'},
                                                {labels: '종교단체등록번호', values: '종교단체등록번호'},
                                                {labels: '여권번호', values: '여권번호'},
                                                {labels: '고유등록번호', values: '고유등록번호'},
                                            ]}
                                        />
                                    </th>
                                    <td colSpan={5}>
                                        <Input 
                                            className={`inputs`}
                                            setValue={(e) => {
                                                datavaluesFunc('매수인', '대리인주민번호', indexNumber, e);
                                            }}
                                            value={x?.values?.find(item => item?.keys === '대리인주민번호')?.values}
                                            name="mb_phone"
                                        />
                                    </td>
                                    <th className='justifys' colSpan={2} >전 화</th>
                                    <td colSpan={5}>
                                        <Input 
                                            className={`inputs`}
                                            setValue={(e) => {
                                                datavaluesFunc('매수인', '대리인전화', indexNumber, e);
                                            }}
                                            value={x?.values?.find(item => item?.keys === '대리인전화')?.values}
                                            name="mb_phone"
                                        />
                                    </td>
                                    <th className='justifys' colSpan={2} >성 명</th>
                                    <td colSpan={4}>
                                        <Input 
                                            className={`inputs`}
                                            setValue={(e) => {
                                                datavaluesFunc('매수인', '대리인성명', indexNumber, e);
                                            }}
                                            value={x?.values?.find(item => item?.keys === '대리인성명')?.values}
                                            name="mb_phone"
                                        />
                                    </td>
                                </tr> 
                            </>
                            }


                            </>
                        );
                    })}
                    
                    <tr>
                        <th className='justifys' style={{ writingMode: 'vertical-lr', lineHeight: '10px', fontSize: 11}} rowSpan={3}>
                            개업공인<br />중개사
                        </th>
                        <th className='justifys' colSpan={6} >사 무 소 소 재 지</th>
                        <td colSpan={23}>
                            <div className='buttonWithTxt' style={{ marginTop: 0 }}>
                                <div>
                                    <Button
                                        className={'normalbutton_middle'}
                                        buttonTxt={'주소찾기'}
                                        onPress={() => {
                                            setIsOpenPost4(!isOpenPost4);
                                        }}
                                    />
                                </div>
                                <div style={{ width: 'calc(100% - 100px)'}}>
                                    <Input 
                                        className={`inputs`}
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '개중사무소소재지1' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '개중사무소소재지1')?.values}
                                        name="mb_phone"
                                    /> 
                                </div>
                            </div>
                            {isOpenPost4  ? (
                                <div style={postBoxStyle}>
                                    <button type="button" className="addrbtn exit_btn" onClick={() => setIsOpenPost4(false)} style={{ padding: 10 }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.79289C5.68342 5.40237 6.31658 5.40237 6.70711 5.79289L12 11.0858L17.2929 5.79289C17.6834 5.40237 18.3166 5.40237 18.7071 5.79289C19.0976 6.18342 19.0976 6.81658 18.7071 7.20711L13.4142 12.5L18.7071 17.7929C19.0976 18.1834 19.0976 18.8166 18.7071 19.2071C18.3166 19.5976 17.6834 19.5976 17.2929 19.2071L12 13.9142L6.70711 19.2071C6.31658 19.5976 5.68342 19.5976 5.29289 19.2071C4.90237 18.8166 4.90237 18.1834 5.29289 17.7929L10.5858 12.5L5.29289 7.20711C4.90237 6.81658 4.90237 6.18342 5.29289 5.79289Z" fill="#999999"/>
                                        </svg>                            
                                    </button>
                                    <DaumPostcode style={postCodeStyle} autoClose onComplete={onCompletePost} />
                                </div>
                            ) : null}
                        </td>
                    </tr>
                    <tr>
                        <th className='justifys' colSpan={6} >사 무 소 명 칭</th>
                        <td colSpan={12}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '개중사무소명칭1' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '개중사무소명칭1')?.values}
                                name="mb_phone"
                            />
                        </td>
                        <th className='justifys' colSpan={4} >대 표 자 명</th>
                        <th className='justifys' colSpan={2} style={{ fontSize: 10, letterSpacing: -1, padding: 2 }} >서명 및 날인</th>
                        <td colSpan={5} style={{ textAlign: 'right'}}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                <div style={{ width: 200, color: 'red' }}>
                                    자필서명
                                </div>                         
                                (인)
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th className='justifys' colSpan={6} >전 화 번 호</th>
                        <td colSpan={4}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '개중전화번호1' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '개중전화번호1')?.values}
                                name="mb_phone"
                            />
                        </td>
                        <th className='justifys' colSpan={3} style={{ fontSize: 11 }} >등 록 번 호</th>
                        <td colSpan={5}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '개중등록번호1' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '개중등록번호1')?.values}
                                name="mb_phone"
                            />
                        </td>
                                                
                        <th className='justifys' colSpan={4} style={{ fontSize: 11 }}>소 속 공 인 중 개 사</th>
                        <th className='justifys' colSpan={2} style={{ fontSize: 10, letterSpacing: -1, padding: 2 }} >서명 및 날인</th>
                        <td colSpan={5} style={{ textAlign: 'right'}}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                <div style={{ width: 200, color: 'red' }}>
                                    자필서명
                                </div>                         
                                (인)
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={30}>
                            <Checkbox
                                linetype={'checkimg'}
                                values={togetherck}
                                setvalues={(e) => {
                                    console.log(e);
                                    settogetherck(e);
                                    setinputArr(inputArr?.map(item => item?.keys === '공동중개여부' ? {...item, values: e?.length > 0 ? e: ''} : item));
                                }}
                                namevalue={[
                                    {names: '공동중개 시 체크해주세요', values: 0},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                            />
                        </td>
                    </tr>
                    {/* {keys: "공동중개", values: [
                        {keys: "공동중개1", values: [
                            {keys: "공동중개사무소소재지", values: '', requireCkr: false, errmsg: ''},
                            {keys: "공동중개사무소명칭", values: '', requireCkr: false, errmsg: ''},
                            {keys: "공동중개전화번호", values: '', requireCkr: false, errmsg: ''},
                            {keys: "공동중개등록번호", values: '', requireCkr: false, errmsg: ''},
                        ], requireCkr: true, subflag: false, errmsg: ''},
                    ], requireCkr: true, errmsg: '공동중개정보를 입력해주세요.'}, */}
                    {inputArr?.find(item => item?.keys === '공동중개')?.values?.map((x, i) => {
                        let rowspan = inputArr?.find(item => item?.keys === '공동중개')?.values?.length;
                        let indexNumber = i;
                        return (
                        <>
                        <tr>
                            <th style={{ fontSize: 11, textAlign: 'center' }} rowSpan={3}>
                                개업공인중개사
                                {rowspan-1 === i &&
                                <div
                                    style={{
                                        display: 'flex', alignItems: 'center', justifyItems: 'center', flexDirection: 'column',
                                        marginTop: 5,
                                    }}
                                >
                                    <button
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '50%' }}
                                        onClick={() => {
                                            let saveArr = [...inputArr?.find(item => item?.keys === '공동중개')?.values];
                                            saveArr.push({keys: "공동중개"+rowspan, values: [
                                                {keys: "공동중개사무소소재지", values: '', requireCkr: false, errmsg: ''},
                                                {keys: "공동중개사무소명칭", values: '', requireCkr: false, errmsg: ''},
                                                {keys: "공동중개전화번호", values: '', requireCkr: false, errmsg: ''},
                                                {keys: "공동중개등록번호", values: '', requireCkr: false, errmsg: ''},
                                            ], requireCkr: true, errmsg: ''});
                                            setinputArr(inputArr?.map((x, i) => {
                                                if(x?.keys === '공동중개'){
                                                    return {...x, values: saveArr}
                                                } else {
                                                    return x;
                                                }
                                            }));

                                        }}
                                    >
                                        <img src="./images/icons/addplus.svg" width='16' />
                                    </button>
                                    {i > 0 &&
                                    <button
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '50%', marginTop: 5 }}
                                        onClick={() => {
                                            if(rowspan === 1) return;
                                            let saveArr = [...inputArr?.find(item => item?.keys === '공동중개')?.values?.filter((item, index) => index !== rowspan-1)];
                                            setinputArr(inputArr?.map((x, i) => {
                                                if(x?.keys === '공동중개'){
                                                    return {...x, values: saveArr}
                                                } else {
                                                    return x;
                                                }
                                            }));

                                        }}
                                    >
                                        <img src="./images/icons/adddelete.svg" width='16' />
                                    </button>}
                                </div>} 
                            </th>
                            <th className='justifys' colSpan={6} >
                                사 무 소 소 재 지
                            </th>
                            <td colSpan={23}>
                                <div className='buttonWithTxt' style={{ marginTop: 0 }}>
                                    <div>
                                        <Button
                                            className={'normalbutton_middle'}
                                            buttonTxt={'주소찾기'}
                                            onPress={() => {
                                                addropennerFunc('공동중개', '공동중개사무소소재지', indexNumber, true) 
                                            }}
                                        />
                                    </div>
                                    <div style={{ width: 'calc(100% - 100px)'}}>
                                        <Input 
                                            className={`inputs`}
                                            setValue={(e) => {
                                                datavaluesFunc('공동중개', '공동중개사무소소재지', indexNumber, e);
                                            }}
                                            value={x?.values?.find(item => item?.keys === '공동중개사무소소재지')?.values}
                                            name="mb_phone"
                                        /> 
                                    </div>
                                </div>
                                {x?.values?.find(item => item?.keys === '공동중개사무소소재지')?.requireCkr ? (
                                    <div style={postBoxStyle}>
                                        <button type="button" className="addrbtn exit_btn" onClick={() => addropennerFunc('공동중개', '공동중개사무소소재지', indexNumber, false)} style={{ padding: 10 }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.79289C5.68342 5.40237 6.31658 5.40237 6.70711 5.79289L12 11.0858L17.2929 5.79289C17.6834 5.40237 18.3166 5.40237 18.7071 5.79289C19.0976 6.18342 19.0976 6.81658 18.7071 7.20711L13.4142 12.5L18.7071 17.7929C19.0976 18.1834 19.0976 18.8166 18.7071 19.2071C18.3166 19.5976 17.6834 19.5976 17.2929 19.2071L12 13.9142L6.70711 19.2071C6.31658 19.5976 5.68342 19.5976 5.29289 19.2071C4.90237 18.8166 4.90237 18.1834 5.29289 17.7929L10.5858 12.5L5.29289 7.20711C4.90237 6.81658 4.90237 6.18342 5.29289 5.79289Z" fill="#999999"/>
                                            </svg>                            
                                        </button>
                                        <DaumPostcode style={postCodeStyle} autoClose onComplete={(data) => addrvaluesFunc('공동중개', '공동중개사무소소재지', indexNumber, data)} />
                                    </div>
                                ) : null}
                            </td>
                        </tr>
                        <tr>
                            <th className='justifys' colSpan={6} >사 무 소 명 칭</th>
                            <td colSpan={12}>
                                <Input 
                                    className={`inputs`}
                                    setValue={(e) => {
                                        datavaluesFunc('공동중개', '공동중개사무소명칭', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '공동중개사무소명칭')?.values}
                                    name="mb_phone"
                                />
                            </td>
                            <th className='justifys' colSpan={4} >대 표 자 명</th>
                            <th className='justifys' colSpan={2} style={{ fontSize: 10, letterSpacing: -1, padding: 2 }} >서명 및 날인</th>
                            <td colSpan={5} style={{ textAlign: 'right'}}>
                                <div className='displayflexstart' style={{ gap: 4 }}>
                                    <div style={{ width: 200, color: 'red' }}>
                                        자필서명
                                    </div>                        
                                    (인)
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th className='justifys' colSpan={6} >전 화 번 호</th>
                            <td colSpan={4}>
                                <Input 
                                    className={`inputs`}
                                    setValue={(e) => {
                                        datavaluesFunc('공동중개', '공동중개전화번호', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '공동중개전화번호')?.values}
                                    name="mb_phone"
                                />
                            </td>
                            <th className='justifys' colSpan={3} style={{ fontSize: 11 }} >등 록 번 호</th>
                            <td colSpan={5}>
                                <Input 
                                    className={`inputs`}
                                    setValue={(e) => {
                                        datavaluesFunc('공동중개', '공동중개등록번호', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '공동중개등록번호')?.values}
                                    name="mb_phone"
                                />
                            </td>
                                                    
                            <th className='justifys' colSpan={4} style={{ fontSize: 11 }}>소 속 공 인 중 개 사</th>
                            <th className='justifys' colSpan={2} style={{ fontSize: 10, letterSpacing: -1, padding: 2 }} >서명 및 날인</th>
                            <td colSpan={5} style={{ textAlign: 'right'}}>
                                <div className='displayflexstart' style={{ gap: 4 }}>
                                    <div style={{ width: 200, color: 'red' }}>
                                        자필서명
                                    </div>                        
                                    (인)
                                </div>
                            </td>
                        </tr>     
                        </>
                        );
                    })}               
                </table>
            </div>          
            <div style={{
                width: '100%', textAlign: 'center', fontSize: 20, fontWeight: 700
            }}>
                {memberinfos?.compony?.title}
            </div>  
            {errmsg &&
            <div className='input_error ' style={{ width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                {errmsg}
            </div>}
            
            <div 
                style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
                    width: '100%', margin: 'auto', marginBottom: 20, gap: 20 
                }}
            >
                <div 
                    style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8,
                        width: '40%', 
                    }}
                >
                    <div style={{ width: '50%' }}>
                        <Button
                            buttonTxt={'닫기'}
                            disabled={true} 
                            onPress={() => { 
                                setdetailwrite(false);
                            }}
                        />                                       
                    </div>
                    <div style={{ width: '50%'}}>
                        <Button
                            buttonTxt={'저장'}
                            styles={{ 
                            }} 
                            onPress={() => { 
                                //inputArr
                                // {keys: "임대할부분", values: '', requireCkr: true, errmsg: '임대할부분을 입력해주세요.'},
                                console.log(inputArr);
                                for(let i = 0; i < inputArr?.length; i++){
                                    console.log(inputArr[i]?.requireCkr);
                                    if(inputArr[i]?.requireCkr === true && inputArr[i]?.values === ''){
                                        seterrmsg(inputArr[i]?.errmsg);
                                        return;
                                    }
                                }

                                contractWirteSubmit(row?.idx ? row?.idx : null, sell_type, category, togetherck?.length > 0 ? 1 : 0, inputArr, sub_category);
                            }}
                        />     
                    </div>                       
                </div>
                {row?.idx*1 > 0 &&
                <div 
                    style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8,
                        width: '30%', 
                    }}
                >
                    <div style={{ width: '100%'}}>
                        <Button
                            buttonTxt={'확인설명서 작성'}
                            styles={{ 
                            }} 
                            onPress={() => { 
                                scrolTopFunc();
                                setviewpages(1);
                            }}
                        />     
                    </div>                       
                </div>     
                }           
            </div>   
        </div>
        {listpopflag === true &&
        <div className='PopupArea'>
            <div>
                <div className='PopupAreaBG' style={{backgroundColor: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(2px)',}}
                    //onClick={() => { setlistpopflag(false); }}
                />
                <div className='PopupAreaContents' style={{ width: 800 }}>
                    <div>
                        <div className="popTitle padding20">
                            <span >매물장에서 가져오기</span>
                            <button
                                onClick={() => {
                                    setlistpopflag(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" width='20' />                                            
                            </button>
                        </div>
                        <div className="padding32">
                            <div className='popcontents'>
                                <div style={{ width: '100%', height: 500, overflow: 'auto' }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder="주소/건물명/매물번호/연락처/용도/비고"
                                        setValue={setsearchvar}
                                        value={searchvar}
                                        name="mb_phone"
                                        allwaysclearflag={true}
                                        searchicons={true}
                                        style={{
                                            paddingLeft: 35,
                                            marginBottom:10
                                        }}
                                    />
                                    <table 
                                        style={{ width: '100%', }}
                                        className='tablelistarea'
                                    >
                                        <thead 
                                            style={{
                                                backgroundColor: '#F2F4F7',
                                                textAlign: "center",
                                                position: "sticky",
                                                top: "0",
                                                border: '1px solid red',
                                                zIndex: 1
                                            }}                        
                                        >
                                            <tr>
                                                <th>매물번호</th>
                                                <th>주소</th>
                                                <th>동·층·호</th>
                                                <th>거래유형</th>
                                                <th>가격</th>
                                                <th>면적</th>
                                            </tr>
                                        </thead>
                                        <tbody className=''>
                                            {viewList?.map((x, i) => {
                                                return (
                                                    <tr
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => {
                                                            let inputArrData = inputArr;

                                                            setsell_type(x?.sell_type);
                                                            setcategory(category_2_list?.find(item => item?.idx*1 === x?.category_2*1)?.group);
                                                            setp_code(x?.p_code);


                                                            
                                                            inputArrData = inputArrData?.map(item => item?.keys === '소재지' ? {...item, values: x?.addr} : item);
                                                            inputArrData = inputArrData?.map(item => item?.keys === '소재지동' ? {...item, values: x?.building_dong} : item);
                                                            inputArrData = inputArrData?.map(item => item?.keys === '소재지호' ? {...item, values: x?.building_unit} : item);
                                                            inputArrData = inputArrData?.map(item => item?.keys === '토지면적' ? {...item, values: x?.area_land} : item);
                                                            inputArrData = inputArrData?.map(item => item?.keys === '건물전용면적' ? {...item, values: x?.area_private} : item);
                                                            inputArrData = inputArrData?.map(item => item?.keys === '매매대금' ? {...item, values: x?.price_sell} : item);
                                                            inputArrData = inputArrData?.map(item => item?.keys === '보증금' ? {...item, values: x?.price_all} : item);
                                                            inputArrData = inputArrData?.map(item => item?.keys === '차임' ? {...item, values: x?.price_month} : item);
                                                            inputArrData = inputArrData?.map(item => item?.keys === '매수인성명' ? {...item, values: x?.client_name} : item);
                                                            inputArrData = inputArrData?.map(item => item?.keys === '매수인전화' ? {...item, values: x?.client_hp} : item);
                                                            inputArrData = inputArrData?.map(item => item?.keys === '건물용도' ? {...item, values: x?.item_usage} : item);
                                                            if(x?.jibhap === '집합'){
                                                                inputArrData = inputArrData?.map(item => item?.keys === '건물전용면적' ? {...item, values: x?.area_private} : item);
                                                            }
                                                            setcategory(x?.jibhap === '일반' ? '일반건물' : '집합건물');
                                                            setinputArr(inputArrData);
                                                            setlistpopflag(false);
                                                        }}
                                                    >
                                                        <td>{x?.idx}</td>
                                                        <td>{x?.addr}</td>
                                                        <td>{`${x?.building_dong||"-"}·${x?.building_floor||"-"}·${x?.building_unit||"-"}`}</td>
                                                        <td>{x?.sell_type}</td>
                                                        <td>{x?.price_sell}</td>
                                                        <td>{x?.area_supply}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='popbuttons'>
                                
                                <div>
                                    <Button
                                        buttonTxt={'닫기'}
                                        onPress={() => { setlistpopflag(false); }}
                                    />                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>        
        }
        
        {listcustompopflag === true &&
        <div className='PopupArea'>
            <div>
                <div className='PopupAreaBG' style={{backgroundColor: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(2px)',}}
                    //onClick={() => { setlistcustompopflag(false); }}
                />
                <div className='PopupAreaContents' style={{ width: 800 }}>
                    <div>
                        <div className="popTitle padding20">
                            <span >고객목록에서 가져오기</span>
                            <button
                                onClick={() => {
                                    setlistcustompopflag(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" width='20' />                                            
                            </button>
                        </div>
                        <div className="padding32">
                            <div className='popcontents'>
                                <div style={{ width: '100%', maxHeight: 500, overflow: 'auto' }}>
                                    <table 
                                        style={{ width: '100%', }}
                                        className='tablelistarea'
                                    >
                                        <thead 
                                            style={{
                                                backgroundColor: '#F2F4F7',
                                                textAlign: "center",
                                                position: "sticky",
                                                top: "0",
                                                border: '1px solid red',
                                                zIndex: 1
                                            }}                        
                                        >
                                            <tr>
                                                <th>고객번호</th>
                                                <th>중개사</th>
                                                <th>고객명</th>
                                            </tr>
                                        </thead>
                                        <tbody className=''>
                                            {customerlist?.map((x, i) => {
                                                return (
                                                    <tr
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => {
                                                            let inputArrData = inputArr;

                                                            setsell_type(x?.sell_type);
                                                            setcategory(category_2_list?.find(item => item?.idx*1 === x?.category_2*1)?.group);
                                                            let names = x?.title;
                                                            let hps = x?.hp;
                                                            inputArrData = inputArrData?.map((x, i) => {
                                                                if(x?.keys === '매도인'){
                                                                    return {...x, values: x?.values?.map((x2, i2) => {
                                                                        return {...x, subflag: x2?.subflag, values: x2?.values?.map((x3, i3) => {
                                                                            if(x3?.keys === '매도인성명'){
                                                                                return {...x3, values: names};
                                                                            } else {
                                                                                return x3;
                                                                            }
                                                                        })}
                                                                    })}
                                                                } else {
                                                                    return x;
                                                                }
                                                            })
                                                            inputArrData = inputArrData?.map((x, i) => {
                                                                if(x?.keys === '매도인'){
                                                                    return {...x, values: x?.values?.map((x2, i2) => {
                                                                        return {...x, subflag: x2?.subflag, values: x2?.values?.map((x3, i3) => {
                                                                            if(x3?.keys === '매도인전화'){
                                                                                return {...x3, values: hps};
                                                                            } else {
                                                                                return x3;
                                                                            }
                                                                        })}
                                                                    })}
                                                                } else {
                                                                    return x;
                                                                }
                                                            })
                                                            // console.log(inputArrData);
                                                            // return;
                                                            
                                                            setinputArr(inputArrData);
                                                            setlistcustompopflag(false);
                                                        }}
                                                    >
                                                        <td>{x?.idx}</td>
                                                        <td>{x?.compony?.title}</td>
                                                        <td>{x?.title}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='popbuttons'>
                                
                                <div>
                                    <Button
                                        buttonTxt={'닫기'}
                                        onPress={() => { setlistcustompopflag(false); }}
                                    />                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>        
        }
        {pdfdowns === true &&
        <div ref={targetRef} >
            <ContractwriterPageViewer
                row={row}
            />
        </div>
        }
        {pdfdowns2 === true &&
        <div ref={targetRefconfirm} >
            {sub_category === '주거용' &&
            <ContractwriterPage2Viewer
                row={row}
            />
            }
            {sub_category === '비주거용' &&
            <ContractwriterPage3Viewer
                row={row}
            />
            }
        </div>
        }
        </>
    )    
}